const ro = {
  maintenance: {
    underMaintenance: "Nightz este în mentenanță",
    backSoon:
      "Nightz este în mentenanță pentru a putea veni cu îmbunătățiri și pentru a va oferi cea mai bună experiență. Ne pare rău pentru incovenienta, vom reveni curând!",
  },
  confirmation: {
    close: "Închide",
    delete: "Șterge",
    accept: "Accept",
    cancel: "Anulează",
    save: "Salvează",
    edit: "Editează",
    confirmDeleteDialogStandardTitle: "Șterge",
    confirmDeleteDialogStandardDescription:
      "Ești sigur că dorești să mergi mai departe cu ștergerea?",
  },

  daysOfTheWeek: {
    monday: "luni",
    tuesday: "marți",
    wednesday: "miercuri",
    thursday: "joi",
    friday: "vineri",
    saturday: "sâmbătă",
    sunday: "duminică",
  },
  daysOfTheWeekShort: {
    monday: "Lun",
    tuesday: "Mar",
    wednesday: "Mie",
    thursday: "Joi",
    friday: "Vin",
    saturday: "Sâm",
    sunday: "Dum",
  },
  guards: {
    permissionDenied: {
      title: "Accesul interzis",
      body: "Nu aveţi permisiunea să accesaţi această pagină.",
    },
  },

  login: {
    title: "Bună, bine ai revenit!",
    header: "Autentifică-te în contul tau Nightz",
    no_account: "Nu ai un cont?",
    start_now: "Începe acum",
    submit: "Autentifică-te",
    forgot_password: "Ai uitat parola?",
    continueWithEmail: "Continuă cu email",
    fields: {
      emailOrPhone: "Email sau telefon",
      password: "Parola",
    },
    validation: {
      emailOrPhone_required: "Emailul sau telefonul este obligatoriu",
      password_required: "Parola este obligatorie",
    },
    errors: {
      Incorrectemailorphoneorpassword: "Credenţiale greșite",
      Toomanyfailedattemptsofloginpleaseresetyourpassword:
        "Prea multe încercări nereușite. Vă rugăm sa vă resetați parola!",
      Incorrectinfo: "Credenţiale greșite",
    },
    withSocials: {
      or: "SAU",
    },
  },

  accountMenu: {
    message:
      "Bună! Pentru a continua, te rugam să te autentifici sau să te inregistrezi",
    login: "Autentifică-te",
    register: "Înregistrează-te",
    logout: "Deconectează-te",
    home: "Acasă",
    tickets: "Bilete și Rezervări",
    profile: "Contul Meu",
    myCart: "Coșul Meu",
    myDashboard: "Panou de Control",
    invoices: "Facturi",
    invoicesDrafts: "Schițele Facturi",
    invoicesDraft: "Schiță Factură",
  },

  search: {
    notFound: "Nu a fost găsit",
    noResult: "Nu s-au găsit rezultate pentru",
    tryTypos:
      "Încercați să verificați greșelile de scriere sau să utilizați cuvinte complete.",
    enterKeywords: "Vă rugăm să introduceți cuvinte cheie",
    searchBar: "Caută",
  },

  registerPage: {
    priceRange: "Prețuri",
    viewMenu: "Deschide meniul",
    reserveTable: "Rezervă o masă",
    pageTitle: "Înregistrare",
    pageMessage: "Înregistrează-te la Nightz",
    title: "Începe absolut gratuit",
    subTitle: "Gasește petreceri peste tot ",
    accountType: "Tipul de cont",
    userType: "Utilizator",
    companyType: "Companie",
    firstName: "Prenume",
    lastName: "Nume de familie",
    emailAddress: "Adresa de email",
    password: "Parola",
    register: "Inregistrează-te",
    message1: "Prin înregistrare, sunt de acord cu Nightz",
    message2: "și",
    termsAndConditionsTitle: "Termeni și Condiții",
    termsAndConditions: "Termenii și condițiile",
    privacyPolicy: "Politica de confidențialitate",
    alreadyAccount: "Ai deja un cont?",
    login: "Autentifică-te",
    firstNameRequired: "Prenumele este obligatoriu",
    lastNameRequired: "Numele de familie este obligatoriu",
    emailAddressRequired: "Adresa de email este obligatorie",
    passwordRequired: "Parola este obligatorie",
    invalidEmail: "Adresa de email este invalida",
    genericError: "A apărut o problemă! Te rugăm să încerci mai târziu.",
  },

  userProfile: {
    title: "Contul meu",
    general: "General",
    notifications: "Notificări",
    socialLinks: "Link-uri sociale",
    changePassword: "Schimbă parola",
  },

  userTicketsPage: {
    title: "Activitățile mele",
    myAccount: "Contul meu",
    tickets: "Bilete și Rezervări",
    upcomingEvents: "Activități viitoare",
    upcomingBookings: "Rezervări viitoare",
    pastEvents: "Activități trecute",
    pastBookings: "Rezervări trecute",
    noUpcomingEventsTickets: "Nu ai activități pentru evenimente viitoare",
    noPastEventsTickets: "Nu ai activități pentru evenimente trecute",
  },

  checkoutPage: {
    cartMaxQuantity: "Nu puteți adăuga mai mult de 50 produse în coș",
  },

  accountGeneral: {
    firstName: "Prenume",
    lastName: "Nume",
    username: "Nume de utilizator",
    phoneNumber: "Număr de telefon",
    country: "Tara",
    city: "Oras",
    about: "Despre",
    saveChanges: "Salvează modificările",
    formatAllowed: "Formatul permis este *.jpeg, *.jpg, *.png",
    maxSize: "Dimensiunea maximă permisă este de {{size}}",
    dashboard: "Panou de control",
    user: "Utilizator",
    accountSettings: "Setări cont",
    updateSuccess: "Actualizare reușită!",
  },

  imageCropper: {
    cancel: "Anulează",
    remove: "Șterge",
    save: "Salvează",
    editImage: "Editează imaginea",
  },

  listingList: {
    title: "Postări",
    subtitleNightz: "Divertisment, restaurante și relaxare",
    subtitleDayz: "Business, networking & dezvoltare",
    freeEntry: "Intrare liberă",
    startingFrom: "Începând de la",
    allCountry: "Toată Ţara",
    seeMore: "Vezi mai mult",
    seeLess: "Vezi mai puțin",
  },

  listingOpenApp: {
    title: "Bilete mai ieftine în aplicație",
    description: "Descarcă aplicația Nightz și primește oferte exclusive la evenimentele și restaurantele din orașul tău!",
    continueInApp: "Continuă cu discount în aplicație",
    continueInWeb: "Cumpără la preț întreg pe site",
  },

  tickets: {
    other: "Alte",
    dates: "Zile",
    configuration: "Configurație",
    spotsLeft: "locuri rămase",
    left: "RĂMASE",
    loadingDates: "Se încarcă datele...",
    noTickets: "Nu mai există bilete disponibile",
    seeMoreDates: "Vezi mai multe zile"
  },

  bookings: {
    plusOneDay: " (+ 1 zi)",
    eventCreatedSuccessfully: "Eveniment creat cu succes!",
    publish: "Publică-l acum",
    goToEvent: "Mergi la eveniment",
    ongoingEvent: "Eveniment în derulare",
    addEvent: "Adaugă Eveniment",
    addNewEvent: "Adaugă eveniment nou",
    createEvent: "Creează eveniment",
    comments: "Comentarii",
    holdingFeeFor: "Taxă de rezervare pentru",
    items: "Produse",
    orderDetails: "Detalii Comandă",
    error: "A fost întâmpinată o eroare. Vă rugăm să incercați mai târziu.",
    errorNoPermissionCompany: "O companie nu are dreptul de a creea rezervări.",
    successReservationMade:
      "O cerere de rezervare a fost făcută cu succes. Verifică mail-ul sau telefonul pentru mai multe informații!",
    errorNotEnoughPlaces:
      "O rezervare nu poate fi făcută pentru că nu sunt suficiente locuri." +
      "Puteți contacta organizatorul pentru mai multe informații",
    contactDetails: "Detalii de contact",
    back: "Înapoi",
    continue: "Continuă",
    successCancel: "Rezervarea a fost anulată cu succes!",
    cancelError: "A apărut o eroare, vă rugăm să încercați din nou.",
    noAvailibityError:
      "Locurile s-au epuizat. Te rugăm să încerci alt interval.",
    numberOfGuest: "oaspete",
    numberOfGuests: "oaspeți",
    yes: "Da",
    no: "Nu",
    busy: "Ocupat",
    alertTitle: "Ești sigur?",
    alertText: "Sunteți sigur că doriți să anulați această rezervare?",
    addTable: "Alege masa",
    addOption: "Alege opțiunea",
    title: "Rezervări",
    on: "Rezervări pe",
    approve: "Aprobă",
    remove: "Elimină",
    modify: "Modifică",
    confirmed: "Confirmat",
    pending: "În așteptare",
    waiting_for_payment: "În curs de plată",
    canceled: "Anulat",
    blocked: "Blocat",
    blockedInterval: "Interval Blocat",
    deleted_by_venue: "Șters de către locație",
    cancel_by_user: "Anulat",
    cancel_by_venue: "Anulat",
    denied: "Respins",
    deny: "Respinge",
    enabled: "Activat",
    disabled: "Dezactivat",
    noStatus: "Fără status",
    newReservation: "Rezervare",
    blockInterval: "Blochează",
    deleteError: "A apărut o eroare, vă rugăm să încercați din nou.",
    createError: "A apărut o eroare, vă rugăm să încercați din nou.",
    rescheduleError: "A apărut o eroare, vă rugăm să încercați din nou.",
    blockError: "A apărut o eroare, vă rugăm să încercați din nou.",
    tables: "mese",
    options: "opțiuni",
    option: "opțiune",
    person: "persoană",
    persons: "persoane",
    table: "masă",
    allTablesAdded: "Toate mesele adăugate",
    oneButtonLeft: "1 buton rămas",
    allButtonsAdded: "Toate butoanele adăugate",
    left: "rămase",
    category: "Categorie",
    area: "Zona",
    guests: "Invitați",
    time: "Ora",
    date: "Data",
    today: "Azi",
    tomorrow: "Mâine",
    save: "Salvează",
    delete: "Șterge",
    cancel: "Anulează",
    fullName: "Nume complet",
    name: "Nume",
    phoneNumber: "Număr de telefon",
    email: "Email",
    contact: "Detalii de contact",
    length: "Durata",
    type: "Scrie...",
    tooManyGuests:
      "Atenție! Capacitatea meselor este sub numărul de invitați. Rezevarea poate să fie salvată în continuare.",
    cancelReservation: "Anulați rezervarea",
    outsideBusinessHours:
      "Rezervările nu pot fi făcute în afara orelor de lucru.",
    startTimeIsInvalid: "Ora de începere este invalidă.",
    endTimeIsInvalid: "Ora de încheiere este invalidă.",
    closedDay: "Astăzi locația este închisă.",
    approveReservation: "Aprobi rezervarea?",
    deleteReservation: "Ștergi rezervarea?",
    giveUp: "Renunță",
    reservationApproved: "Rezervarea a fost aprobată!",
    reservationDeleted: "Rezervarea a fost ștearsă!",
    noAvailableBookingCardOptions:
      "Nu există opțiuni disponibile. Încearcă altă combinație.",
    allTablesSoldOut:
      "Toate mesele au fost rezervate!",
    allOptionsSoldOut:
      "Toate opțiunile au fost rezervate!",
    loadingBookingCardOptions: "Vă rugăm să așteptați.",
    visit: "vizită",
    visits: "Vizite",
    lastVisit: "Ultima vizită",
    dragToMove: "Trage pentru a te mișca",
    bookTableYouWant1: "Vezi locația și alege",
    bookTableYouWant2: "exact masa care îți place",
    exploreTheVenue: "Explorează locația în 3D și alege cea mai bună masă, ca un VIP. Această opțiune premium este disponibilă doar în aplicație.",
    chooseYourTable: "Alege masa în aplicație",
    randomAllocation: "Continuă cu alocarea aleatorie",
    specialRequirements: "Spune-ne mai multe despre preferințele tale ca să îți putem oferi cea mai bună experiență.",
    specialOccasions: "Ocazie Specială",
    dietaryRestrictions: "Restricții Alimentare",
    tableRequirements: "Cerințe Masă",
    clientTags: "Tags Client",
    specialOccasionsTitle: "Este o ocazie specială?",
    userDietaryRestrictionsTitle: "Ai vreo restricție alimentară?",
    partyDietaryRestrictionsTitle: "Are grupul tău vreo restricție alimentară?",
    anythingElseTitle: "Altceva pentru a îți îmbunătăți vizita?",
    characters: "caractere",
    reservationTags: "Tags Rezervare",
    add: "Adaugă",
    selectTable: "Selectează minim o masă",
    showMore: "Arată mai mult",
    showLess: "Arată mai puțin",
    formValidation: {
      statusRequired: "Statusul este obligatoriu.",
      guestsRequired: "Numărul de invitați este obligatoriu.",
      guestsMin: "Obligatoriu",
      dateRequired: "Data este obligatorie.",
      startTimeRequired: "Ora de începere este obligatorie.",
      endTimeRequired: "Ora de încheiere este obligatorie.",
      areaRequired: "Zona este obligatorie.",
      tablesRequired: "Cel puțin o masă este obligatorie.",
      optionsRequired: "Cel puțin o opțiune este obligatorie.",
      categoryRequired: "Categoria este obligatorie.",
      fullNameRequired: "Numele complet este obligatoriu.",
      phoneNumber: "Numărul de telefon este obligatoriu.",
      phoneNumberLength: "Vă rugăm să puneți un număr de telefon corect",
      emailRequired: "Adresa de email este obligatorie.",
      emailValid: "Introduceți o adresă de email validă.",
    },
    clientBookingValidation: {
      guestsRequired: "Numărul de invitați este obligatoriu.",
      dateRequired: "Data este obligatorie.",
      timeRequired: "Ora este obligatorie.",
      areaRequired: "Zona este obligatorie.",
      lengthRequired: "Durata obligatorie.",
    },
    bookingDetails: {
      title: "Detalii rezervare",
    },
    table: {
      name: "Nume",
      status: "Status",
      searchByIdNamePhoneEmail:
        "Caută după nume, email, id sau număr de telefon",
      guests: "Invitați",
      area: "Zona",
      category: "Categorie",
      options: "Opțiuni",
      tables: "Mese",
      time: "Data si ora rezervarii",
      phone: "Telefon",
      email: "E-Mail",
      id: "ID-ul rezervarii",
      reset: "Resetează",
      reservationsTitle: "Rezervări",
    },
    howItWorks: "Cum funcționează",
    holdingFee: "Taxă de rezervare",
    holdingFeeDisclaimer:
      "Această locație folosește o taxă de rezervare pentru a confirma selecția și pentru a evita absențele. Această sumă va fi scăzută din nota de plată.",
  },
  bookingTags: {
    Anniversary: "Aniversare",
    Bachelor: "Petrecere Burlaci",
    Bachelorette: "Petrecere Burlăcițe",
    Birthday: "Zi de Naștere",
    BridalShower: "Petrecere Mireasă",
    BusinessMeeting: "Întâlnire de Afaceri",
    Engagement: "Logodnă",
    Graduation: "Absolvire",
    Honeymoon: "Lună de Miere",
    AlcoholFree: "Fără Alcool",
    Allium: "Allium",
    Celery: "Țelină",
    Crustacean: "Crustacee",
    DairyFree: "Fără Lactate",
    Diabetic: "Diabetic",
    Eggs: "Ouă",
    Fish: "Pește",
    GlutenFree: "Fără Gluten",
    Halal: "Halal",
    Kosher: "Kosher",
    LactoseIntolerant: "Intoleranță la Lactoză",
    Lupin: "Lupin",
    MilkDairy: "Lapte/Lactate",
    Mollusc: "Moluște",
    Mustard: "Muștar",
    Nightshade: "Nightshade",
    Paleo: "Paleo",
    Peanuts: "Arahide",
    Pescatarian: "Pescatarian",
    Pork: "Porc",
    Poultry: "Pasăre",
    Pregnant: "Gravidă",
    RedMeat: "Carne Roșie",
    Salt: "Sare",
    Seafood: "Fructe de Mare",
    Sesame: "Susan",
    Shellfish: "Crustacee și Moluște",
    Soy: "Soia",
    Sulfites: "Sulfiți",
    TreeNuts: "Nuci",
    Vegan: "Vegan",
    Vegetarian: "Vegetarian",
    Wheat: "Grâu",
    FirstVisit: "Prima Vizită",
    FoodCritic: "Critic Gastronomic",
    FrequentCancellations: "Anulări Frecvente",
    FrequentNoShow: "Neprezentări Frecvente",
    HighSpender: "Client Generos",
    Media: "Media",
    Regular: "Client Fidel",
    StaffAcquaintance: "Cunoscut al Personalului",
    VIP: "VIP",
    AccessibleEntrance: "Intrare Accesibilă",
    BabySeat: "Scaun pentru Bebeluș",
    BarSeat: "Loc la Bar",
    Booth: "Separeu",
    ExtendedStay: "Ședere Prelungită",
    GuideDog: "Câine Ghid",
    HighTable: "Masă Înaltă",
    Indoor: "Interior",
    NonSmoking: "Non-Fumători",
    Outdoor: "Exterior",
    Patio: "Terasă Acoperită",
    PrivateDining: "Sală Privată",
    QuietArea: "Zonă Liniștită",
    Smoking: "Fumători",
    Terrace: "Terasă",
    WheelchairAccessible: "Acces Scaun cu Rotile",
    WindowSeat: "Loc la Fereastră"
  },
  bookingWizard: {
    title: "Alegeți preferințele",
    tickets: "Bilete",
    booking: "Masă",
    options: "Opțiuni",
    bookingMenu: "Meniu",
    seatsTitle: "Alegeți locurile",
  },

  checkout: {
    cart: {
      cart: "Coș",
      clearCart: "Golește coșul",
      clearCartSubtitle: "Ești sigur că vrei să ștergi toate produsele din coș?",
      ticketsMaxQuantity: "Nu puteți adăuga mai multe bilete!",
      increase: "Cantitatea a fost crescută",
      decrease: "Cantitatea a fost scăzută",
      itemDelete: "Produsul a fost șters cu succes!",
      itemDeleteError: "Produsul nu a putut fi șters!",
      itemUpdateError: "Produsul nu a putut fi actualizat!",
    },
    congrats: {
      "ticket": "Felicitări! Biletele au fost achiziționate cu succes!",
      "table": "Felicitări! Rezervarea a fost efectuată cu succes!",
      "order": "Felicitări! Comanda a fost efectuată cu succes!",
      "ticketAction": "Vezi biletele",
      "tableAction": "Vezi rezervarea",
      "orderAction": "Vezi detalii",
      "callToAction": "Super, mersi!"
    },
    invoiceDetails: "Detalii de facturare",
    personalDetails: "Detalii personale",
    title: "Pagina de plată",
    item: "produs",
    items: "produse",
    emptyCartTitle: "Coșul este gol",
    emptyCartDescription:
      "Se pare că nu ai adăugat nimic în coșul de cumpărături.",
    continueShopping: "Continuă cumpărăturile",
    orderSummary: "Rezumat comandă",
    checkout: "Confirmă comanda",
    cartMaxQuantity: "Nu puteți adăuga mai mult de 50 produse în coș!",
    acceptTermsAndConditions: "Vă rugăm să acceptați termenii și condițiile!",
    subtotal: "Subtotal",
    discount: "Reducere",
    processingFee: "Taxă de procesare",
    paymentMethodFee: "Taxă metodă de plată",
    vatIncluded: "TVA inclus dacă e aplicabil.",
    discountCode: "Cod de reducere",
    applyDiscount: "Aplică",
    promoCodeApplied: "Codul de reducere a fost aplicat cu succes.",
    product: "Produs",
    products: "Produse",
    seat: "Locuri",
    price: "Preț",
    quantity: "Cantitate",
    totalPrice: "Preț total",
    ticketType: "Tipul de bilete",
    available: "Disponibile",
    changeQty: "Modifică",
    iReadAndAgree: "Am citit și sunt de acord cu",
    agreeToCampaign: "Sunt de acord să primesc informații despre evenimente viitoare.",
    personalInvoice: "Factură personală",
    businessInvoice: "Factură companie",
    sameAsPersonal: "Detaliile de facturare la fel ca detaliile personale",
    billing: {
      addressTitle: "Adresa de facturare",
      title:
        "Vă rugăm să completați următorul formular cu datele dumneavoastră",
      validation: {
        firstName: "Prenumele este obligatoriu",
        lastName: "Nume de familie este obligatoriu",
        postCode: "Codul poşta este obligatoriu",
        digits: "Codul poştal trebuie să conțină doar cifre",
        phoneDigits: "Numărul de telefon trebuie să conțină doar cifre",
        phoneMax: "Numărul de telefon trebuie să aibă cel mult 15 cifre",
        phoneMin: "Numărul de telefon trebuie să aibă cel putin 7 cifre",
        phone: "Numărul de telefon este obligatoriu",
        email: "Adresa de email este obligatorie",
        emailFormat: "Adresa de email este invalidă",
        emailsMatching: "Adresele de email trebuie sa corespundă",
        address: "Adresa este obligatorie",
        city: "Orașul este obligatoriu",
        state: "Județul este obligatoriu",
      },
      firstName: "Prenume",
      lastName: "Nume de familie",
      address: "Adresa de facturare",
      city: "Localitate / Oraş",
      phone: "Număr de telefon",
      email: "Adresa de email",
      validateEmail: "Confirmă adresa de email",
      state: "Județ",
      country: "Ţară",
      postCode: "Cod poştal",
      back: "Înapoi",
      continueToPayment: "Continuă către plată",
    },
    completeOrder: "Finalizează comanda",
    edit: "Modifică",
    emailDelivery: "Primește pe email",
    deliveryOptions: "Opțiuni de livrare",
    payment: {
      payment: "Livrare și plată",
      options: "Opțiuni de plată",
      title1: "Plătește cu un card nou",
      title2: "Plătește cu un card salvat",
      titlePlatform: "Plătește cu Google / Apple Pay",
      confirm: "Confirmă Plata",
      description:
        "Vei fi redirecționat pe pagina Banca Transilvania pentru a completa plata în siguranță.",
      cards: "Carduri",
      expiration: "Expiră în",
      newCard: "Adaugă un card nou",
      deleteCard: "Şterge cardul selectat",
      loading:
        "Vă rugăm să nu închideți fereastra. Cererea dumneavoastră este în curs de procesare.",
      cancel: "Anulează",
    },
    genericError: "A apărut o problemă! Te rugăm să încerci mai târziu.",
    ticketInviteError: "Nu poți trimite invitații la un mail de companie. Te rugăm să încerci din nou.",
    notEnoughCapacityError: "Nu mai există destule locuri pentru această sesiune. Te rugăm să încerci din nou.",
    errors: {
      noPromoCodeError: "Acest cod de reducere nu este valabil!",
      noOnlySpacesError: "Nu se pot folosi numai spații",
    },
    success: {
      title: "Vă mulţumim pentru achiziţia dumneavoastră!",
      order1: "Comanda",
      order2: "a fost plasată.",
      mail: "Vei primi un mail cu biletele achiziționate în curând.",
      mail2: "Vei primi un mail cu detaliile comenzii în curând.",
      download: "Alternativ, le poți descărca folosind butonul de mai jos.",
      problems: "Dacă întâmpini probleme, nu ezita să ne contactezi.",
    },
    fail: {
      title: "OOPS!",
      message1: "Se pare că a apărut o eroare la plasarea comenzii.",
      message2: "Te rugăm să încerci mai târziu.",
      messageCode_104: "Card restricționat (blocat temporar sau permanent)",
      messageCode_124:
        "Tranzacția nu poate fi autorizată din cauza acordului guvernului, băncii centrale sau instituției financiare, legi sau reglementări",
      messageCode_320: "Card inactiv. Vă rugăm activați cardul.",
      messageCode_801: "Emitent indisponibil.",
      messageCode_803:
        "Card blocat. Contactați banca emitentă sau reîncercați tranzacția cu alt card.",
      messageCode_804:
        "Tranzacția nu este permisă. Contactați banca emitentă sau reîncercați tranzacția cu alt card.",
      messageCode_805: "Tranzacție respinsă.",
      messageCode_861: "Dată expirare card greșită.",
      messageCode_871: "CVV gresit.",
      messageCode_905: "Card invalid. Acesta nu există în baza de date.",
      messageCode_906: "Card expirat.",
      messageCode_913:
        "Tranzacție invalidă. Contactați banca emitentă sau reîncercați tranzacția cu alt card.",
      messageCode_914: "Cont invalid. Vă rugăm contactați banca emitentă.",
      messageCode_915: "Fonduri insuficiente.",
      messageCode_917: "Limită tranzacționare depășită.",
      messageCode_952: "Suspect de fraudă.",
      messageCode_998:
        "Tranzacția în rate nu este permisă cu acest card. Te rugăm să folosești un card de credit emise de Banca Transilvania.",
      messageCode_341016:
        "Autentificarea 3DS2 este refuzată de Authentication Response (ARes) - emitent",
      messageCode_341017:
        "Starea autentificării 3DS2 în ARes este necunoscută - emitent",
      messageCode_341018: "3DS2 CReq a fost anulat - client",
      messageCode_341019: "3DS2 CReq a eșuat - client/emitent",
      messageCode_341020: "3DS2 stare necunoscută în RReq - emitent",
    },
    paymentProcessorMaintenance:
      "Procesatorul de plăți este în mentenanță. Vă rugăm să încercați mai târziu.",
  },

  months: {
    january: "Ianuarie",
    february: "Februarie",
    march: "Martie",
    april: "Aprilie",
    may: "Mai",
    june: "Iunie",
    july: "Iulie",
    august: "August",
    september: "Septembrie",
    october: "Octombrie",
    november: "Noiembrie",
    december: "Decembrie",
  },
  calendar: {
    month: 'Lună',
    week: 'Săptămână',
    day: 'Zi'
  },

  passwordValidation: {
    uppercase: "Cel puțin o litera mare",
    lowercase: "Cel puțin o litera mică",
    number: "Cel putin o cifră",
    specialCharacter: "Cel puțin un simbol sau caracter special",
    passwordLength: "Cel puțin 8 caractere",
  },

  changePassword: {
    oldPassword: "Parola veche",
    newPassword: "Parola noua",
    confirmPassword: "Confiră noua parolă",
    oldPasswordRequired: "Parola veche este necesară",
    newPasswordRequired: "Parolă nouă este necesară",
    newPasswordLength: "Parola trebuie să aibă cel puțin 6 caractere",
    passwordMismatch: "Parolele trebuie să se potrivească",
    success: "Actualizare reușită!",
    errors: {
      invalidoldpassword: "Vechea parolă este greșită!",
    },
  },

  resetPassword: {
    passwordRecoveryPrompt: "Ți-ai uitat parola?",
    passwordRecoveryInstructions:
      "Vă rugăm să introduceți adresa de e-mail asociată cu contul dvs. și vă vom trimite un cod pentru a vă reseta parola.",
    resetPasswordInstructions1Email:
      "Am trimis un cod de 6 cifre la adresa ta de email.",
    resetPasswordInstructions2Email:
      "Te rugăm să introduci codul in căsuța de mai jos pentru a-ți verifica emailul.",
    resetPasswordInstructions1Phone:
      "Am trimis un cod de 6 cifre la numărul tău de telefon.",
    resetPasswordInstructions2Phone:
      "Te rugăm să introduci codul in căsuța de mai jos pentru a-ți verifica numărul.",
    returnToSignIn: "Înapoi la autentificare",
    emailOrPhoneRequired: "Emailul este obligatoriu",
    emailOrPhone: "Email",
    emailLabel: "Adresa de email",
    sendRequest: "Trimite cererea",
    passwordCharLimit: "Parola trebuie să aibă cel puțin 6 caractere",
    passwordRequired: "Parola este necesară",
    confirmPassRequired: "Confirmarea parolei este necesară",
    passMismatch: "Parolele trebuie să se potrivească",
    password: "Parola nouă",
    confirmPassword: "Confirmă parola nouă",
    changePasswordSuccess: "Schimbarea parolei a reușit!",
    updatePassword: "Actualizează parola",
    requestSentSuccessfully: "Cerere trimisă cu succes!",
    codeRequired: "Codul este necesar",
    errors: {
      invalidcode: "Codul este invalid!",
      usernotfound: "Nu s-a gasit niciun utilizator cu acea adresa de email!",
    },
  },

  productPage: {
    upcomingEvents: "Evenimente Viitoare",
    openNow: "Deschis",
    closedNow: "Închis",
    opensAt: "Deschide la",
    closesAt: "Închide la",
    opens: "Deschide",
    getTicketsAndTable: "Bilete & Mese",
    getTicket: "Cumpără Bilete",
    getTicketsAndOption: "Bilete & Opțiuni",
    getOptionAndMenu: "Opțiuni & Meniu",
    getTableAndMenu: "Mese & Meniu",
    call: "Sună",
    getVoucher: "Cumpără Vouchere",
    back: "Înapoi",
    freeAccess: "ACCES GRATUIT",
    noTicket: "Nu aveți nevoie de bilet pentru a participa",
    noPublishedTickets: "BILETELE NU SUNT DE VANZARE INCA",
    comeBack: "Încercați mai târziu",
    dialogTitle: "Ai un bilet pentru un alt eveniment în coș",
    dialogAction: "Mergi la checkout",
    addToCartSuccesss: "Biletele au fost adăugate în coș cu succes!",
    comingSoon: "În curând",
    soldOut: "Vânzare încheiată",
    tickets: "Bilete",
    vouchers: "Vouchere",
    organizer: "Organizator",
    gallery: "Galerie",
    overview: "Descriere",
    priceRange: "Preț",
    viewMenu: "Deschide Meniul",
    viewTickets: "Bilete",
    viewBooking: "Rezervare",
    reserveTable: "Rezervă Masă",
    reserve: "Reserve",
    dialogContent:
      "Dacă dorești să cumperi un bilet pentru acest eveniment, trebuie mai întâi să finalizezi procesul de checkout pentru cel care este deja în coș",
    typeOfTicket: "Tipul de bilet",
    onlyinApp: "disponibil doar în aplicație",
    redeem: "Cumpără în app",
    typeOfTicketError:
      "Problemă la validarea biletului! Te rog să reîncarci pagina.",
    addToCart: "Adaugă în Coş",
    update: "Actualizează",
    quantity: "Cantitate",
    buyNow: "Cumpără",
    addedToCart: "Adăugat în coș",
    chooseSeats: "Alege locurile",
    chooseTickets: "Inapoi la bilete",
    organizerEmail: "Email-ul organizatorului",
    organizerPhone: "Telefonul organizatorului",
    DatabaseError:
      "Problemă la comunicarea cu baza de date! Te rog să încerci mai târziu.",
    genericError: "A apărut o problemă! Te rog să încerci mai târziu.",
    continue: "Continuă",
    itemsInYourCartTitle: "Aveți deja produse în coș",
    itemsInYourCartDescription:
      "Dacă doriți să cumpărați produse pentru acest eveniment, trebuie să vă ștergem produsele din coș.",
    cancel: "Anulează",
  },

  verifyCode: {
    errorVerifying: "Eroare în timpul verificării!",
    successfulVerifying: "Verificare cu succes!",
    codeRequired: "Codul este necesar",
    verify: "Verifică",
  },

  landingPage: {
    title: "Ieșirea perfectă începe cu",
    subTitle1:
      "Nightz este o platformă de socializare dinamică și imersivă creată",
    subTitle2: "pentru a îmbunătăți planificarea iesirilor în oras.",
    events: "Postări",
    business: "Business",
    signIn: "Autentifică-te",
    signUp: "Înregistrează-te",
    home: "Acasă",
    allRightsReserved: "Toate drepturile rezervate",
    madeBy: "creat de",
    logout: "Deconectează-te",
    logoutError: "A apărut o problemă! Te rugăm să încerci mai târziu.",
  },
  landingPageV2: {
    become_partner_button: "Să începem",
    become_partner_title: "DEVINO PARTENER",
    become_partner_description:
      "Ești proprietar de locație sau organizator de evenimente? Creează un cont de business și promovează-ți activitatea în câteva minute.",
    trending_carousel_title: "TRENDING",
    trending_carousel_description:
      "Descoperă cele mai bune evenimente și restaurante recomandate de Nightz.",
    trending_carousel_button: "Mai Mult",
    friends_title: "PRIETENI",
    friends_description:
      "Nightz este cea mai rapidă și simplă cale de a ieși în oraș cu prietenii." +
      " Suntem prima rețea de socializarea pe bune, de aceea vrem să fii offline.",
    friends_button: "Hai pe Nightz",
    discover_title: "DESCOPERĂ",
    discover_description:
      "Descoperă cele mai cool evenimente, restaurante sau activități de făcut în weekend." +
      " Cu Nightz, întregul proces devine o experiență placută de socializare.",
    discover_button: "Explorează",
    chat_and_plan_title: "PLANIFICĂ",
    chat_and_plan_description:
      "Discută cu prietenii și planifică ieșiri împreună. " +
      "Începe planul cu o activitate sau creează un grup cu prietenii și decide mai târziu ce să faceți.",
    chat_and_plan_button: "Planifică",
    stay_in_loop_title: "RĂMÂI CONECTAT",
    stay_in_loop_description_mobile:
      "Ieșiri reușite, oriunde ai fi. Află cine vrea să iasă diseară în oraș și primește recomandări  în funcție de locație. Vrei să ieși singur? Ascunde-ți profilul ca să nu fii deranjat.",
    stay_in_loop_description_web:
      "Ieșiri reușite, oriunde ai fi. Află care dintre prietenii tăi vor să facă ceva diseară în orașul în care " +
      "te afli și primește recomandări de evenimente și " +
      "restaurante bazate pe locație. Vrei să ieși singur? Ascunde-ți profilul ca să nu fii deranjat.",
    stay_in_loop_button: "Ieși în Oraș",
    faster_easier_title: "MAI RAPID, MAI UȘOR",
    faster_easier_description: "Decoperă activități, discută cu prietenii și cumpără bilete: fără link-uri în bio și site-uri externe. Tot ce ai nevoie, într-o singură aplicație, simplu și rapid. Pentru că Nightz e despre destinație, nu despre călătorie.",
    faster_easier_button: "Alătură-te Acum",
    host_your_own_title: "ORGANIZEAZĂ",
    host_your_own_description: "N-ai chef să ieși în oraș? Adună-ți prietenii și planifică ceva chill: o seară de jocuri, o cabană, orice îți trece prin cap. Orice prieten se poate alătura planului, dar trebuie să îi accepți cererea inainte să vadă întreaga listă de participanți.",
    host_your_own_button: "Organizează"
  },
  businessPage: {
    showMore: "Afișează mai mult",
    showLess: "Afișează mai puțin",
    powerhouseTitle: "MOTORUL AFACERII TALE",
    powerhouseSubtitle: "Oferim restaurantelor și evenimentelor o platformă completă care gestionează și crește rezervările și vânzările de bilete, oferind în același timp cea mai bună experiență clienților.",
    powerhouseAction1: "Începe acum",
    powerhouseAction2: "Contactează-ne",
    innovateTitle: "INOVEAZĂ-ȚI AFACEREA",
    innovateSubtitle: "Nu urmăm trenduri. Le creăm.",
    innovateCardTitle1: "Rezervări de mese pentru evenimente",
    innovateCardSubtitle1: "Fără tabele Excel, apeluri telefonice sau neprezentări în ultima clipă. Acum poți vinde mese și pachete promoționale înainte de eveniment.",
    innovateCardAction1: "Încearcă Acum",
    innovateCardTitle2: "Primul recepționer AI",
    innovateCardSubtitle2: "Angajatul AI care poate prelua rezervări telefonice și răspunde la întrebări despre restaurantul tău ca o persoană reală, chiar și în afara orelor de program.",
    innovateCardAction2: "Sun-o pe Allison",
    smartTicketingTitle: "TICKETING MAI INTELIGENT, AUDIENȚĂ MAI MARE",
    smartTicketingSubtitle: "Vinde bilete ușor, crește-ți audiența și gestionează totul într-un singur loc.",
    smartTicketingAction: "Configurează vânzarea de bilete",
    fillTablesTitle: "OCUPĂ MESELE FĂRĂ STRES",
    fillTablesSubtitle: "Automatizăm rezervările și îți oferim unelte pentru a gestiona oaspeții și a construi loialitatea fără efort.",
    fillTablesAction: "Configurează rezervările",
    visibilityVelocityTitle: "TRANSFORMĂ VIZUALIZĂRILE ÎN ÎNCASĂRI",
    visibilityVelocitySubtitle: "Nightz aduce afacerea ta în fața audienței potrivite — exact când contează.",
    visibilityVelocityAction: "Începe analiza",
    investmentTitle1: "NIGHTZ NU ESTE UN COST, ",
    investmentTitle2: "ESTE O INVESTIȚIE",
    investmentSubtitle: "Uită de abonamente. Plătești doar când vinzi. Prosperăm când afacerea ta prosperă, de aceea vrem să te ajutăm să vinzi cum n-ai mai făcut-o până acum.",
    investmentAction: "Începe să Vinzi",
    investmentCardTitle1: "BILETE",
    investmentCardValue1: "5% din toate vânzările online de bilete",
    investmentCardSubtitle1: "scad odată cu volumul",
    investmentCardTitle2: "REZERVĂRI",
    investmentCardValue2: "5% din cheltuiala lead-urilor noastre",
    investmentCardSubtitle2: "2.5% pentru clienții tăi recurenți",
    pricesStartAt: "prețurile încep de la",
    ticketingSection: {
      tableTitle: "Serviciul de Ticketing",
      ticketingFeatures: {
        feature1: "Pagină personalizată fără branding pentru evenimente",
        description1: "Nightz este despre evenimentul tău. De aceea ne limităm brandingul la minimum.",
        feature2: "Evenimente nelimitate",
        description2: "Gestionează un număr nelimitat de evenimente din același cont.",
        feature3: "Categorii de bilete nelimitate",
        description3: "Fiecare categorie are un număr de serie unic.",
        feature4: "Design personalizat pentru bilete",
        description4: "Setează culori personalizate pentru designul biletelor.",
        feature5: "Sistem de vânzări early bird",
        description5: "Generează categorii de bilete cu prețuri progresive. Când cele ieftine sunt epuizate, cele mai scumpe se activează automat, pe rând.",
        feature6: "Promoții de grup",
        description6: "Inovația Nightz: Reducere pentru grupuri care colectează datele tuturor participanților, crescând baza de date de marketing cu 30% pentru fiecare eveniment.",
        feature7: "Promoții în aplicație",
        description7: "Stabilește prețuri mai mici pentru bilete în aplicația mobilă, pentru a fideliza audiența cu notificări push personalizate, invitații și reduceri.",
        feature8: "Coduri de reducere",
        description8: "Creează coduri de reducere pentru clienții fideli sau în colaborare cu influenceri.",
        feature9: "Invitații la eveniment",
        description9: "Trimite invitații prin email și în aplicație clienților fideli. Când aceștia sunt invitați, toți prietenii lor sunt notificați, generând promovare organică.",
        feature10: "Planuri de sală cu locuri",
        description10: "Teatre, cinematografe, săli de conferință - creăm orice plan personalizat pentru spectacole care vând bilete cu loc în sală.",
        feature11: "Statistici de vânzări în timp real",
        description11: "Începe să măsori veniturile și tendințele de cumpărare imediat ce evenimentul este publicat.",
        feature12: "Statistici de marketing în timp real",
        description12: "Identifică principalele canale de generare de lead-uri și analizează eficiența campaniilor tale de marketing folosind linkuri personalizate.",
        feature13: "Scanner în aplicația mobilă",
        description13: "Scanează biletele direct din aplicație, folosind un număr nelimitat de dispozitive.",
        feature14: "Colectarea și plata automată a taxelor",
        description14: "Dacă este activată, această opțiune ne permite să ne ocupăm de întreaga birocrație și taxe în diverse piețe europene. Ca tu să vinzi fără stres.",
        feature15: "Plăți săptămânale automate",
        description15: "Plățile se fac în fiecare luni, dar sunt disponibile plăți anticipate pentru o taxă fixă de 25RON per tranzacție.",
        feature16: "Conturi multiple pentru angajați",
        description16: "Creează și gestionează toate conturile angajaților într-un singur loc. Funcțiile disponibile pentru ei sunt doar scanarea biletelor și gestionarea rezervărilor. Le poți restricționa accesul oricând.",
      }
    },
    reservationsSection: {
      tableTitle: "Serviciul de Rezervări",
      reservationsFeatures: {
        feature1: "Pagină personalizată fără branding pentru locație",
        description1: "Nightz este despre restaurantul tău. De aceea ne limităm brandingul la minimum.",
        feature2: "Locații nelimitate",
        description2: "Gestionează un număr nelimitat de locații din același cont.",
        feature3: "Widget de rezervare pe site-ul propriu",
        description3: "Implementează widgetul nostru de rezervare cu o soluție low-code pe orice site în mai puțin de 5 minute.",
        feature4: "Rezervări live 24/7",
        description4: "Primește rezervări oricând, chiar și în afara programului.",
        feature5: "Calendar cu rezervări live",
        description5: "Vezi, adaugă și modifică toate rezervările într-un singur loc. Toate schimbările apar instant.",
        feature6: "Confirmare automată sau manuală",
        description6: "Activează confirmarea automată pentru a face procesul instantaneu sau păstrează-l manual pentru mai mult control.",
        feature7: "Notificări instant",
        description7: "Prin email/SMS și în aplicația mobilă pentru cereri și actualizări de rezervare.",
        feature8: "Atribuire inteligentă",
        description8: "Alocă automat rezervările meselor vacante pentru a maximiza ocuparea locației. Elimină erorile de rezervare.",
        feature9: "Aplicație mobilă pentru gestionarea rezervărilor",
        description9: "Primește notificări push când se adaugă sau anulează rezervări. Gestionează toate rezervările din calendarul general de pe un număr nelimitat de dispozitive.",
        feature10: "Fidelizarea clienților",
        description10: "Primește informații despre loialitatea clienților în funcție de numărul de rezervări efectuate.",
        feature11: "Configurare personalizată a rezervărilor",
        description11: "Definește ore de funcționare, durate minime și maxime ale rezervărilor.",
        feature12: "Configurare zone personalizate",
        description12: "Definește zone și mese rezervabile (ex: terasă, rooftop, salon etc.)",
        feature13: "Configurare personalizată a meselor",
        description13: "Definește mesele conform planului locației. Setează capacitatea și avansul pentru rezervare.",
        feature14: "Avansuri pentru rezervare",
        description14: "Stabilește un avans pentru a elimina neprezentările și a crește profitul. Poate fi setat la nivel de locație, zonă sau mărime a mesei.",
        feature15: "Precomandă meniu",
        description15: "Permite precomenzi gratuite sau plătite pentru meniu, pentru a accelera servirea și a îmbunătăți fluxul de numerar. Încasările sunt plătite zilnice, automat.",
        feature16: "Gestionarea comenzilor",
        description16: "Vezi toate articolele pre-comandate de clienți.",
        feature17: "Statistici rezervări în timp real",
        description17: "Identifică tendințele zilnice, săptămânale sau lunare pentru a îmbunătăți ocuparea restaurantului.",
        feature18: "Statistici marketing în timp real",
        description18: "Identifică principalele canale de lead-uri și analizează eficiența campaniilor cu linkuri personalizate.",
        feature19: "Integrare POS",
        description19: "Monitorizează cheltuielile clienților, identifică clienții valoroși și optimizează profitabilitatea meselor.",
        feature20: "Conturi multiple pentru angajați",
        description20: "Creează și gestionează toate conturile angajaților într-un singur loc. Funcțiile disponibile pentru ei sunt doar scanarea biletelor și gestionarea rezervărilor. Le poți restricționa accesul oricând.",
        feature21: "Alerte în timp real privind cheltuielile clienților",
        description21: "Fii notificat când un client valoros depășește o anumită sumă. Poți oferi promoții și fidelizare.",
        feature22: "Recenzii filtrate",
        description22: "Urâm recenziile false la fel de mult ca tine. De aceea, setăm o sumă minimă cheltuită pentru a putea lăsa o recenzie.",
        feature23: "Etichete pentru clienți",
        description23: "Atribuie etichete clienților: VIP, fideli, problematici, cu alergii sau preferințe.",
        feature24: "Listă de așteptare",
        description24: "Clienții se pot înscrie pe listă când nu sunt mese disponibile. Sunt notificați când se eliberează o masă, fără a fi nevoie să aștepte la intrare.",
        feature25: "Planuri de sală personalizabile",
        description25: "Te ajutăm să construiești planuri de sală potrivite locației tale, pentru a gestiona rezervările mai ușor.",
        feature26: "Recepționerul AI",
        description26: "Uită de apeluri. Angajatul nostru AI poate prelua rezervări telefonice și răspunde la întrebări despre restaurant sau promoții ca o persoană reală, chiar și în afara programului. Numele și vocea sunt personalizabile.",
      }
    },
    marketingSection: {
      tableTitle: "Funcționalități Marketing",
      marketingFeatures: {
        feature1: "Publicare gratuită pe site și aplicație",
        description1: "Nightz este creat pentru toți cei care ies des în oraș, oferind oportunitatea de a-ți promova afacerea către clienți noi, valoroși.",
        feature2: "Promovare regională/națională",
        description2: "Crește-ți vizibilitatea în regiunile apropiate sau la nivel național cu categoria \"în trend\" de pe Nightz. Pentru rezultate optime, durata minimă este o săptămână, iar prețul variază în funcție de numărul de regiuni.",
        feature3: "Promovare bazată pe performanță",
        description3: "Afaceri cu performanțe bune sunt promovate automat în \"top 10 experiențe\" din fiecare oraș. Clasamentul se actualizează zilnic, în funcție de biletele și rezervările efectuate în ultimele 7 zile",
        feature4: "Informații despre canalele de vânzare",
        description4: "Identifică cele mai profitabile canale de lead-uri. Compară-le cu concurența pentru a găsi oportunități de îmbunătățire.",
        feature5: "Informații demografice",
        description5: "Folosim analize avansate conforme GDPR pentru a consolida demografia publicului tău. Astfel poți înțelege mai bine audiența și crea strategii mai bune.",
        feature6: "Campanii personalizate",
        description6: "Trimite notificări în aplicație, campanii email sau SMS către clienți pentru a-i ține aproape. Taxele variază în funcție de tipul și volumul campaniei.",
      }
    }
  },

  categories: {
    event: "Eveniment",
    theatre: "Teatru",
    experience: "Experiență",
    restaurant: "Restaurant",
    custom: "Custom",
    chill: "Chill",
    conference: "Conferință",
    sportEvent: "Eveniment Sportiv",
    landmark: "Monument",
    bar: "Bar",
    coffeeShop: "Cafenea",
    headingSubcategoryNightz: "Alege una dintre opțiunile Nightz",
    headingSubcategoryDayz: "Alege una dintre opțiunile Dayz",
    headingCategory: "În ce categorie se potrivește activitatea ta?",
    backToMyListings: "Înapoi la Postările Mele",
  },

  platformSettings: {
    title: "Setările Platformei",
    subtitle: "Interfaţă administrator",
  },

  voucherGeneration: {
    title: "Generare Vouchere",
    subtitle: "Generează vouchere pe care utilizatorii le pot aplica la checkout.",
    form: {
      voucherTitle: "Titlu Voucher",
      userEmail: "Email Utilizator",
      applicableListing: "Postări Aplicabile",
      expiryDate: "Data De Expirare",
      discountType: "Tip Discount",
      discountAmount: "Valoare Discount",
      maxUsage: "Maxim Utilizări (Total)",
      maxUsagePerListing: "Maxim Utilizări Pe Postare",
      percent: "Procent (%)",
      fixed: "Valoare Fixă",
      multiple: "Procente (%)",
      applicableToAll: "Aplicabil la toate postările",
      or: "SAU"
    },
    action: "Generează Voucher",
    success: "Voucher creat cu succes!",
    error: "Eroare la crearea voucherului. ",
    generatedVouchers: "Vouchere",
    generatedVouchersSubtitle: "Vezi detalii despre voucherele generate și aplicările lor.",
    uploadDoc: "Încarcă dovada cazării"
  },
  voucherValidation: {
    title: "Validare Vouchere",
    subtitle: "Validează și aplică vouchere pentru magazinul tău.",
    code: "Cod voucher",
    validate: "Validează",
    instructions: "Introdu codul de pe voucher pentru a-l valida și a aplica reducerea la magazniul tău",
    instructions2: "Alege evenimentul și introdu codul de pe voucher pentru a-l valida și a aplica reducerea",
    success: "Voucher aplicat cu succes!",
    name: "Nume",
    codeShort: 'Cod',
    expiry: "Expiră",
  },
  vouchersTable: {
    firstName: "Prenume",
    lastName: "Nume",
    phone: "Telefon",
    email: "Email",
    voucherCode: "Cod Voucher",
    generatedBy: "Generat de",
    accomodationInvoice: "Dovadă Cazare",
    availability: "Disponbilitate",
    usage: "Folosiri"
  },

  companiesList: {
    title: "Lista companiilor",
    subtitle: "Interfaţă administrator",
    view: "Vizualizează",
    edit: "Switch pentru editarea câmpurilor",
    save: "Salvează",
    download: "Descarcă tabelul",
    searchNamePlaceholder: "Caută după nume, telefon sau email...",
    tableHeader: {
      name: "Nume",
      emailAccount: "Email Cont",
      phoneAccount: "Număr Telefon Cont",
      company: "Companie",
      cui: "CUI",
      cuiPopover: "Codul Unic de Înregistrare",
      documents: "Documente",
      status: "Status",
    },
    statusTypes: {
      pending: "În curs de verificare",
      banned: "Respins",
      approved: "Acceptat",
      selfManaged: "Verificare proprie",
      draft: "Schiţă",
    },
    tableCellPopover: {
      all: "Toate documentele încărcate",
      mandatory: "Certificatul de înregistrare si Contractul b2b încărcate",
      notMandatory:
        "Certificatul de înregistrare si Contractul b2b NU au fost încă încărcate",
    },
    registerForm: {
      title: "Aprobare cont companie",
      description:
        "Verifică toate informaţiile companiei şi setează comisionul de ticketing conform contractului.",
      status: "Satus companie",
      commissionTickets: "Comision pentru bilete",
      commissionBooking: "Comision pentru rezervări",
      commissionPaidByUser: "Comision plătit de"
    },
    errorMessages: {
      required: "Acest camp este obligatoriu",
      min: "Comisionul trebuie sa fie mai mare sau egal cu 0",
      max: "Comisionul trebuie sa fie mai mic sau egal cu 100",
    },
  },
  eventTicketsTable: {
    status: {
      ISSUED: "EMIS",
      SCANNED: "SCANAT",
      REFUNDED: "RAMBURSAT"
    },
    ticketSeries: "Seria biletului",
    orderID: " ID Comandă",
    seatId: "Număr loc",
    buyerName: "Nume cumpărător",
    holderName: "Nume deținător",
    ticketsType: "Tipul de bilet",
    ticketPrice: "Prețul biletului",
    ticketStatus: "Statusul biletului",
    phone: "Număr de telefon",
    email: "Email",
    itemId: "ID produs",
    itemName: "Nume produs",
    itemQuantity: "Cantitate",
    itemUnitPrice: "Preț per unitate",
    title: "Produse"
  },

  imageGallery: {
    title: "Trage sau Selectează un fișier",
    drop: "Trage fișierele aici sau apasă pe ",
    browse: " navighează",
    message: " prin calculatorul tău.",
  },

  transactionTab: {
    excelOptions: {
      ordersOnly: "Tranzacții",
      ticketsAndOrders: "Tranzacții și Produse",
    },
  },

  eventManager: {
    categories: "Categorii",
    options: "Opțiuni",
    addModule: "Adaugă Modul",
    statusTypes: {
      created: "Creat",
      draft: "Schiță",
      ready: "Pregătit",
      pending: "În curs de verificare",
      ongoing: "În progres",
      expired: "Expirat",
      deleted: "Șters",
      cancelled: "Anulat",
      waitingForPayment: "În curs de plată",
    },
    seats: {
      send: "Trimite",
      cancel: "Anulează",
      sendTicketInvite: "Trimite Invitație",
      ticketInvite: "Invitație",
      eventId: "ID Eveniment:",
      selectedSeats: "Locuri selectate",
      numberOfTickets: "Număr de bilete",
      name: "Nume",
      emailAddress: "Adresă mail"
    },
    title: {
      newEvent: "Creează o Postare",
      editEvent: "Editează",
    },
    notApprovedDurationTitle: "Sunt necesare acțiuni suplimentare:",
    notApprovedDurationBody:
      "Pentru a schimba data, trebuie să ștergi mai întâi rezervările actuale.",
    notApprovedDurationButton: "OK",
    modulesSummary: {
      endTimeError: "End time is earlier than start time",
      settingsTitle: "Setări de Administrare",
      settingsDescription:
        "Controlează caracteristicile principale ale evenimentului, precum categoria, tag-urile, statutul și vizibilitatea.",
      durationTitle: "Durată",
      durationDescription:
        "Spuneți oamenilor când începe și se termină evenimentul dumneavoastră sau dacă serviciile dumneavoastră sunt disponibile permanent.",
      generalDetailsTitle: "Detalii Generale",
      generalDetailsDescription:
        "Denumiți evenimentul sau locația, setați imaginea principală de copertă și spuneți o poveste audienței dumneavoastră.",
      locationTitle: "Locație",
      locationDescription:
        "Informați oamenii despre locația evenimentului și fiți descoperiți de persoanele din zonă.",
      ratingTitle: "Rating",
      ratingDescription:
        "Configurați alte linkuri asociate cu listarea dumneavoastră.",
      contactTitle: "Detalii de Contact",
      contactDescription:
        "Configurați linkurile dumneavoastră sociale precum și metodele prin care oamenii pot lua legătura cu dumneavoastră.",
      imageGalleryTitle: "Galerie de Imagini",
      imageGalleryDescription:
        "Creează un impact vizual adăugând imagini impresionante ale produselor sau serviciilor dumneavoastră.",
      ticketingTitle: "Bilete",
      ticketingDescription:
        "Configurați bilete personalizate gratuite sau cu plată, adăugați coduri promoționale și trimiteți invitații pentru evenimentul dumneavoastră.",
      openingHoursTitle: "Program de funcționare",
      openingHoursDescription:
        "Informați clienții despre ora de deschidere și de închidere.",
      reservationsTitle: "Rezervări",
      reservationsDescription:
        "Definiți spații rezervabile în cadrul locației dumneavoastră și începeți să gestionați rezervările instantaneu.",
      reservationsMenuTitle: "Rezervări cu meniu",
      reservationsMenuDescription: "Definiți meniuri rezervabile.",
    },
    warningDeleteModal: {
      standardWarningDeleteTitle: "Ștergere Modul",
      standardWarningDeleteMessage:
        "Doriți ca acest modul să fie șters și toate datele asociate cu acesta să fie de asemenea și ele șterse?",
    },
    nameLabel: "Nume",
    tableTitle: "Zone disponibile",
    priceLabel: "Preț",
    addArea: "Adaugă zonă",
    tableTitleCategory: "Categorii",
    addCategory: "Adaugă Categorie",
    editOption: "Editează",
    deleteOption: "Șterge",
    editModalNewAreaTitle: "Adaugă zonă nouă",
    editModalExistingAreaTitle: "Editează zona",
    editModalNameLabel: "Numele zonei",
    editModalPriceLabel: "Prețul mesei",
    editModalNewCategoryTitle: "Adaugă categorie nouă",
    editModalExistingCategoryTitle: "Editează categoria",
    editModalCategoryNameLabel: "Numele categoriei",
    editModalCategoryPriceLabel: "Prețul categoriei",
    forbiddenDeleteAreaDialogTitle: "Eroare",
    forbiddenDeleteAreaDialogDescription:
      "Zona acesta nu poate fi ștearsă deoarece există mese care aparțin de ea." +
      " Șterge mai întâi mesele respective și după vei putea șterge zona aceasta",
    forbiddenDeleteCategoryDialogDescription:
      "Categoria acesta nu poate fi ștearsă deoarece există opțiuni care aparțin de ea." +
      " Șterge mai întâi opțiunile respective și după vei putea șterge categoria aceasta",
    forbiddenDeleteTableDialogDescription:
      "Masa acesta nu poate fi ștearsă deoarece există rezervări în viitor care aparțin de ea." +
      " Șterge mai întâi rezervările respective și după vei putea șterge masa aceasta",
    forbiddenDeleteOptionDialogDescription:
      "Opțiunea acesta nu poate fi ștearsă deoarece există rezervări în viitor care aparțin de ea." +
      " Șterge mai întâi rezervările respective și după vei putea șterge opțiunea aceasta",
    noAreaTitle: "Modulul de rezervări este incomplet!",
    noAreaBody:
      "Te rugăm să adaugi zone și mese sau să elimini modulul pentru a publica activitatea.",
    noCategoryBody:
      "Te rugăm să adaugi categorii și opțiuni sau să elimini modulul pentru a publica activitatea.",
    noAreaButton: "Ok",
    spaces: {
      nameLabel: "Nume",
      areaLabel: "Zonă",
      categoryLabel: "Categorie",
      capacityLabel: "Capacitate",
      priceLabel: "Preț",
      tableTitle: "Mese disponibile",
      optionTitle: "Opțiuni",
      addOption: "Adaugă Opțiune",
      addSpace: "Adaugă Masă",
      addSpaces: "Adaugă Multiple",
      addMultipleModalConfirm: "Adaugă Mese",
      addMultipleModalTitle: "Adaugă multiple mese deodată",
      addMultipleModalDescription: "Te rugăm să completezi template-ul Excel cu toate detaliile pentru a adăuga multiple mese.",
      addMultipleOptionsModalConfirm: "Adaugă Opțiuni",
      addMultipleOptionsModalTitle: "Adaugă multiple opțiuni deodată",
      addMultipleOptionsModalDescription: "Te rugăm să completezi template-ul Excel cu toate detaliile pentru a adăuga multiple opțiuni.",
      editOption: "Editează",
      deleteOption: "Șterge",
      editModalNewSpaceTitle: "Adaugă o masă nouă",
      editModalExistingSpaceTitle: "Editează masa",
      editModalNameLabel: "Numele mesei",
      editModalCapacityLabel: "Capacitatea mesei",
      editModalPriceLabel: "Prețul mesei",
      noAreasModalTitle: "Nu a fost găsită nicio zonă",
      editModalNewOptionTitle: "Adaugă o opțiune nouă",
      editModalExistingOptionTitle: "Editează opțiunea",
      editModalOptionNameLabel: "Numele opțiunii",
      editModalOptionCapacityLabel: "Capacitatea opțiunii",
      editModalOptionPriceLabel: "Prețul opțiunii",
      noCategoriesModalTitle: "Nu a fost găsită nicio categorie",
      priceError: "Prețul trebuie să fie mai mare sau egal cu 0",
      capacityError: "Capacitatea trebuie să fie mai mare sau egală cu 0",
      nameError: "Numele este obligatoriu",
      noAreasModalDescription:
        "Nu a fost găsită nicio zonă din care masa să facă parte. Te rugăm să adaugi mai întâi o zonă.",
      noCategoriesModalDescription:
        "Nu a fost găsită nicio categorie din care opțiunea să facă parte. Te rugăm să adaugi mai întâi o categorie.",
    },
    menus: {
      vat: "TVA",
      tableTitle: "Produse din meniu",
      nameLabel: "Nume",
      categoryLabel: "Categorie",
      priceLabel: "Preț",
      quantityLabel: "Cantitate",
      addMenu: "Adaugă Produs",
      addMenus: "Adaugă Multiple",
      addMultipleModalConfirm: "Adaugă produse",
      addMultipleModalTitle: "Adaugă multiple produse deodată",
      addMultipleModalDescription: "Te rugăm să completezi template-ul Excel cu toate detaliile pentru a adăuga multiple produse.",
      editOption: "Editează",
      deleteOption: "Șterge",
      editModalNewMenuTitle: "Adaugă un produs nou",
      editModalExistingMenuTitle: "Editează produsul",
      editModalNameLabel: "Nume",
      editModalCategoryLabel: "Categorie",
      editModalPriceLabel: "Preț",
      editModalQuantityLabel: "Cantitate",
      editModalMetricLabel: "Unitate de măsură",
      category: {
        APPETIZERS: "Aperitive",
        BREAKFAST: "Mic Dejun",
        SPECIALS: "Specialități",
        SOUPS: "Supe",
        SALADS: "Salate",
        MAIN_COURSE: "Fel Principal",
        SIDES: "Garnituri",
        PASTA_RISOTTO: "Paste & Risotto",
        PIZZA: "Pizza",
        FLATBREAD: "Lipii",
        BURGERS: "Burgeri",
        FISH: "Pește",
        SEAFOOD: "Fructe de Mare",
        GRILL: "Grătar",
        CHICKEN: "Specialități din Pui",
        PORK: "Specialități din Porc",
        BEEF: "Specialități din Vită",
        PLATTER: "Platouri",
        VEGETARIAN_VEGAN: "Opțiuni Vegetariene / Vegane",
        SNACKS: "Snacks",
        SAUCES: "Sosuri",
        DESSERTS: "Deserturi",
        PROMOTIONAL_PACKAGES: "Pachete Promoționale",
        SOFT_DRINKS: "Băuturi Răcoritoare",
        JUICES_SMOOTHIES: "Sucuri & Smoothies",
        TEA_COFFEE: "Ceai & Cafea",
        BEER: "Bere",
        ALCOHOLIC_COCKTAIL: "Cocktails",
        NON_ALCOHOLIC_COCKTAIL: "Cocktails fără Alcool",
        WINES: "Vinuri",
        WINES_GLASSES: "Vinuri la Pahar",
        WINE_BOTTLES: "Vinuri la Sticlă",
        SPARKLING_WINES: "Vinuri Spumante",
        VODKA: "Vodcă",
        TEQUILA: "Tequila",
        GIN: "Gin",
        WHISKEY: "Whiskey",
        COGNAC: "Coniac",
        LIQUOUR: "Lichior",
        PALINCA: "Pălincă",
        SHOTS: "Shots",
        CIGARETTES: "Țigări",
      },
      quantityMetric: {
        GRAM: "g",
        KILOGRAM: "kg",
        MILLILITER: "ml",
        LITER: "l",
        PIECE: "buc",
        SLICE: "felie",
        CUP: "cupă",
        BOWL: "bol",
        PLATE: "farfurie",
        BOTTLE: "sticlă",
        GLASS: "pahar",
        SHOT: "shot",
        PINT: "halbă",
        HALF_PINT: "1/2 halbă"
      },
    },
    bookingSettings: {
      cardLabel: "Setări pentru rezervări ",
      menuCardLabel: "Setări pentru meniu",
      menuSettingsDescription: "Dacă această opțiune este dezactivată, meniul este afișat doar cu scop informațional. Activează opțiunea pentru a permite precomandarea produselor din meniu.",
      bookingIntervalLabel: "Interval rezervări",
      bookingDurationLabel:
        "Duratelele posibile ale unei rezervări (în minute)",
      automaticConfirmationLabel: "Confirmare automată a unei rezervări",
      enabledMenuPurchaseLabel: "Cumpărare produse din meniu",
      enabledSpecialRequirementsLabel: "Cerințe speciale pentru rezervări",
      enabledHoldingFeePerPersonLabel: "Taxă de rezervare per persoană",
      isBookableUnitLabel: "Înlocuiește zonele și mesele cu  categorii și opțiuni rezervabile",
      holdingFeeLabel: "Taxă pentru crearea unei rezervări",
      bookingIntervalPart1: "În fiecare",
      bookingIntervalPart2: "de minute",
    },
    sessions: {
      all: "Toate",
      session: "Sesiune",
      addSession: "Adaugă Sesiune",
      addMultiple: "Adaugă Multiple",
      defineYourSessions: "Definește Sesiunile",
      generateSessions: "Generează Sesiuni",
      editSession: "Editează",
      title: "Titlu",
      capacity: "Total Bilete Disponibile",
      startDate: "Oră de început",
      endDate: "Oră de sfârșit",
      ticketTypes: "Bilete",
      eventKey: "Seats.io Event Key",
      addSingle: "Adaugă o Sesiune",
      addMultipleSessions: "Adaugă Multiple Sesiuni",
      sessionDetails: "Detalii Sesiune",
      dateRange: "Interval",
      bookTickets: "Rezervă",
      bookTicketsLong: "Rezervă Bilete",
      hold: "Rezervate",
      available: "Disponibile",
      saveEventFirst: "Te rugăm să salvezi evenimentul înainte!",
      for: "pentru",
      delete: "Șterge Sesiunea",
      copyPrevious: "Copiază ziua precedentă"
    },
    embedIframe: {
      title: "Embed Iframe",
      descriptionPart1:
        "Pentru a implementa sistemul de creare de rezervari in site-ul dumneavoastra, puteti sa folositi generatorul de mai jos, care va creea un Iframe cu valorile de width si height specificate. In cazul in care aveti nevoie de asistenta, nu ezitati sa ne ",
      descriptionV2:
        "Pentru a implementa sistemul în site-ul tău, poți folosi generatorul de mai jos, care va creea un Iframe cu link-ul evenimentului și valoarea height specificată. În cazul În care ai nevoie de asistență, nu ezita să ne ",
      descriptionPart2: "contactezi.",
      width: "Width (px)",
      height: "Height (px)",
      submit: "Generate",
      copyText: "Copy code",
      copySuccess: "Iframe copied to clipboard",
      copyFailure: "Failed to copy iframe to clipboard",
      theme: "Tema",
      darkLabel: "Întunecat",
      lightLabel: "Luminos",
    },
    closeCurrentDay: "Deschis acum!   Închide accesul pentru această zi",
    openCurrentDay: "Închis acum!   Deschide accesul pentru această zi",
    toggleModuleTrue: "ACTIVAT",
    toggleModuleFalse: "DEZACTIVAT",
    listing: "Postare",
    listings: "Postările mele",
    seasonPassNoListings: "Nu există postări în intervalul definit de acest abonament",
    dashboard: "Postările mele",
    business: "Afacerea mea",
    delete: "Şterge",
    deleteMessage: "Eşti sigur că vrei să ştergi",
    items: "elemente",
    item: "element",
    edit: "Editează",
    duplicate: "Duplicare",
    selected: "selectate",
    new: "Postare nouă",
    clear: "Şterge selecția",
    entryType: "Tipul de intrare",
    free: "Gratis",
    ticket: "Bilet",
    ditlReport: "Raportare DITL",
    ditlReportQuestion: "Doriți raportare la DITL?",
    yes: "Doresc",
    no: "Nu doresc",
    subcategory: "Subcategorie",
    subcategories: {
      Event: "Eveniment",
      Restaurant: "Restaurant",
      CoffeeShop: "Cafenea",
      Experience: "Experiență",
      Landmark: "Obiectiv Turistic",
      Chill: "Chill",
      Bar: "Bar",
      NewYearsParty: "Revelion",
      Concert: "Concert",
      Culture: "Cultură",
      Club: "Club",
      Festival: "Festival",
      SportEvent: "Eveniment sportiv",
      Conference: "Conferință",
      OutdoorActivity: "Activitate în natură",
      Beach: "Plajă",
      HikingTrail: "Traseu montan",
      SkiResort: "Stațiune de schi",
      Museum: "Muzeu",
      StandUp: "Stand Up",
      Volunteering: "Voluntariat"
    },
    subcategoriesPlural: {
      Event: "Evenimente",
      Restaurant: "Restaurante",
      CoffeeShop: "Cafenele",
      Experience: "Experiențe",
      Landmark: "Obiective Turistice",
      Chill: "Chill",
      Bar: "Baruri",
      NewYearsParty: "Revelioane",
      Concert: "Concerte",
      Culture: "Cultură",
      Club: "Cluburi",
      Festival: "Festivaluri",
      SportEvent: "Evenimente sportive",
      Conference: "Conferințe",
      OutdoorActivity: "Activități în natură",
      Beach: "Plaje",
      HikingTrail: "Trasee montane",
      SkiResort: "Stațiuni de schi",
      Museum: "Muzee",
      StandUp: "Stand Up",
      Volunteering: "Voluntariate"
    },
    bookLink: "Link de rezervare",
    menuLink: "Link de meniu",
    noVisibleticketsError: "Cel puțin un bilet trebuie să fie vizibil!",
    eventName: "Numele Postării",
    description: "Descriere",
    writeSomethingAwesome: "Scrie ceva interesant...",
    nightzComissionTicket: "Comisionul Nightz pentru bilete",
    nightzComissionTicketText:
      "Comisionul pe care Nightz îl va lua de pe urma evenimentului din vânzări de bilete",
    nightzComissionBooking: "Comisionul Nightz pentru rezervări",
    nightzComissionBookingText:
      "Comisionul pe care Nightz îl va lua de pe urma evenimentului din rezervări",
    mainImage: "Imaginea principală a postării",
    mainImageMobile: "Imagine Trending Fundal Mobile",
    mainImageWeb: "Imagine Trending Fundal Web",
    images: "Imagini",
    useImagesModuleEnable: "Adăugare mai multe imagini postării tale",
    useImagesModuleDisable:
      "Dezactivează opțiunea de a avea mai multe imagini postării. ",
    createOpeningHoursModuleTitle: "Adăugare Modul de Opening Hours",
    createOpeningHoursModuleDescription:
      "Doriți crearea unui modul special pentru Opening Hours prin care să personalizați programul în cadrul listării dumneavoastră?",
    deleteOpeningHoursModuleTitle: "Ștergere Modul de Opening Hours",
    deleteOpeningHoursModuleDescription:
      "Doriți ștergerea modului de Opening Hours?",
    createReservationsModuleTitle: "Adăugare Modul de Rezervări",
    createReservationsModuleDescription:
      "Doriți crearea unui modul special pentru Rezervări prin care veți putea manageria rezervările?",
    deleteReservationsModuleTitle: "Ștergere Modul de Rezervări",
    deleteReservationsModuleDescription:
      "Doriți ștergerea modului de rezervări? Dacă vei continua, toate datele asociate acestui modul vor fi șterse definitiv.",
    useOpeningHoursModuleEnable:
      "Adăugă modulul de opening hours. Acesta îți permite să configurezi pentru fiecare zi " +
      "intervalul de ore în care listarea ta e deschisă pentru vizitare",
    useOpeningHoursModuleDisable: "Dezactivează modulul de opening hours.",
    useReservationsModuleEnable:
      "Adăugă modulul de rezervări. Acesta îți permite primești rezervări în cadrul locației tale. Necesită eveniment de tip permanent sau unic.",
    useReservationsModuleDisable: "Dezactivează modulul de rezervări.",

    createReservationsMenuModuleTitle: "Adăugare Modul de Rezervări cu meniu",
    createReservationsMenuModuleDescription:
      "Doriți crearea unui modul special pentru Rezervări cu meniu prin care veți putea manageria rezervările cu meniu?",
    deleteReservationsMenuModuleTitle: "Ștergere Modul de Rezervări cu meniu",
    deleteReservationsMenuModuleDescription:
      "Doriți ștergerea modului de Rezervări cu meniu.",
    useReservationsMenuModuleEnable:
      "Adăugă modulul de rezervări cu meniu. Acesta îți permite primești rezervări cu meniu în cadrul locației tale. Necesită modulul de rezervări.",
    useReservationsMenuModuleDisable:
      "Dezactivează modulul de rezervări cu meniu.",

    useTicketsModuleEnable: "Adăugă modulul de bilete postării tale",
    useTicketsModuleDisable: "Dezactivează modulul de bilete postării tale. ",
    forbiddenDeleteTicketsModuleModalTitle: "Ștergerea Modulului de Bilete",
    forbiddenDeleteTicketsModuleModalDesc:
      "Acest modul nu poate fi șters deoarece vânzarea biletelor a început deja. " +
      "Pentru a șterge modulul contactează un Account Manager, deoarece este necesară " +
      "rambursarea contravalorii biletelor cumpărate.",
    allowedDeleteTicketsModuleModalDesc:
      "Ștergerea acestui modul cauzează ștergerea tuturor categoriilor de bilete create." +
      " Continui ștergerea modulului?",
    normalTickets: "Bilete normale",
    vouchers: "Vouchere",
    earlyBirdTickets: "Bilete early bird",
    name: "Nume",
    percent: "Procent",
    promoCodes: "Coduri de promoție",
    ticketSubcategories: "Categorii bilete",
    serialNumber: "Număr de serie",
    initialTickets: "Bilete inițiale",
    remainingTickets: "Bilete rămase",
    ticketDesign: "Design bilete",
    ticketImage: "Imagine Bilet",
    ticketsModule: "Modulul de Bilete",
    displayedPrice: "Preț afisat",
    addTicket: "Adaugă bilet",
    addVoucher: "Adaugă voucher",
    eventKey: "Hartă cu locuri",
    mapContactUs1: "Permite participanților să-și aleagă locurile cu ajutorul hărților interactive cu locuri, folosind o soluție  modernă implementată de stadioane și teatre din toată lumea. ",
    mapContactUs2: " și vom crea o hartă personalizată pentru evenimentul tău!",
    mapContactUs: "Contactează-ne",
    tooManySeats: "Poți trimite invitații pentru maxim 10 locuri o dată",
    editTicket: {
      ticketName: "Numele biletului",
      voucherName: "Numele voucherului",
      numberOfAvailableTickets: "Numărul de bilete disponibile",
      numberOfAvailableVouchers: "Numărul de vouchere disponibile",
      priceReportDITL: "Prețul raportat la DITL",
      priceCashout: "Sumă încasată dorită",
      displayedPrice: "Prețul afișat",
      ticketPrice: "Prețul biletului",
      commisionNightz: "Comisionul Nightz",
      paidByCompany: "Plătit de compania ta",
      paidByBuyer: "Plătit de cumpărător",
      commisionDitl: "Impozit Ditl",
      valueNightzTva: "Valoare TVA Nightz",
      valueClientTva: "Valoare TVA Companie",
      invoiceToNightz: "Valoare facturată către Nightz",
      ticketDescription: "Descrierea biletului",
      addTicket: "Adaugă bilet",
      addVoucher: "Adaugă voucher",
      saveTicket: "Salvează",
      participants: "Participanți",
      percent: "Procent",
      discountPerPerson: "Discount pe persoană (%)",
      price: "Preț",
      ticketPromotionType: "Tip promoție",
      noPromotion: "Fără promoție",
      appOnlyPromotion: "Doar în aplicație",
      tierPromotion: "Promoție de tip tiered",
      normalPrice: "Preț normal",
      editTicket: "Editează biletul",
      addNewTicket: "Adaugă bilet nou",
      cancel: "Anulează",
      selectSessionsManually: "Alege Manual Sesiunile",
      addAllSessions: "Adaugă Toate Sesiunile",
      eventSessions: "Sesiuni",
      errors: {
        ticketNumberRequired: "Numărul de bilete este necesar",
        ticketNumberMin: "Numărul de bilete trebuie să fie mai mare decât 0",
        ticketNumberMax: "Numărul de bilete nu poate fi mai mare decât 10",
        ticketNumberInteger: "Numărul de bilete trebuie să fie un număr întreg",
        ticketPromotionPriceValue: "Prețul este obligatoriu",
        ticketPriceRequired: "Prețul pe bilet este necesar",
        ticketPriceDitlRequired: "Prețul pe bilet este necesar",
        ticketNameRequired: "Numele biletului este necesar",
        ticketValueNumber: "Prețul biletului trebuie să fie un număr",
        ticketPromotionPriceLimit:
          "Prețul trebuie să fie mai mic decât cel anterior.",
        ticketPromotionLowerParticipantLimit:
          "Numărul de participanți trebuie să fie mai mare decât 1",
        ticketPromotionParticipantLimit:
          "Numărul de participanți trebuie să fie mai mare decât cel anterior.",
        ticketPromotionPriceLimit:
          "Prețul trebuie să fie mai mic decât cel al nivelului anterior",
        ticketPromotionDefaultPriceLimit: "Prețul trebuie să fie mai mic decât cel standard",
        ticketPromoPriceRequired: "Prețul promoțional este obligatoriu",
        maxPercentage: "Procentajul nu poate fi mai mare de 100%",
        nrPercentageRequired: "Procentajul este obligatoriu",
        minNrPercentage:
          "Numărul minim de procentaj trebuie să fie mai mare de 1",
        maxNrPercentage: "Numărul trebuie să fie mai mic de 100.",
      },
    },
    editPromoCode: {
      addNewPromoCode: "Adaugă un nou cod de promoție",
      editPromoCode: "Editează codul de promoție",
      name: "Code de Promoție",
      percent: "Discount Procentual",
      addPromoCode: "Adaugă Cod de Promoție",
    },
    editTicketSubcategory: {
      addNewTicketSubcategory: "Adaugă o nouă categorie de bilete",
      editTicketSubcategory: "Editează categoria de bilete",
      name: "Categorie de bilete",
      addTicketSubcategory: "Adaugă categorie de bilete",
    },
    invite: {
      send: "Trimite",
      title: "Invită-ți prietenii",
      name: "Nume complet",
      email: "Adresa de email",
      quantity: "Numărul de bilete",
      success: "Invitatiile au fost trimise cu succes",
      validation: {
        quantityRequired: "Cantitatea de bilete este necesară",
        quantityAvailable: "Cantitate invalida.",
        quantityDigits: "Cantitatea de bilete trebuie sa contina doar cifre",
        nameRequired: "Numele complet este necesar",
      },
    },
    noTicket: "Niciun bilet emis în prezent.",
    category: "Categorie",
    insights: "Detalii",
    typesOfMusic: "Tipuri de muzică",
    dateAndTimeInfo: "Informații despre dată si ora",
    opening: "Deschidere",
    closing: "Închidere",
    startDate: "Ora de început a evenimentului",
    endDate: "Ora de sfârșit a evenimentului",
    validFrom: "Valid de la",
    validTo: "Valid până la",
    contactInfo: "Informații de contact",
    venueInfo: "Informații despre restaurant",
    facebook: "Profilul tău de facebook",
    instagram: "Profilul tău de instagram",
    tiktok: "Profilul tău de tiktok",
    organizerWebsite: "Link-ul către website-ul tău",
    organizerEmail: "Adresa de email a organizatorului",
    venueEmail: "Adresa de email",
    organizerPhone: "Numărul de telefon al organizatorului",
    twilioPhone: "Număr de telefon Twilio",
    organizerDisplayName: "Numele afișat al organizatorului",
    tags: "Tags",
    currency: "Valută",
    ticketTypes: "Bilete",
    legalName: "Numele legal al organizatorului",
    cuiOrganizer: "CUI-ul organizatorului",
    locationVenue: "Sală de spectacol",
    street: "Strada și numărul",
    city: "Orașul",
    county: "Județul",
    venueName: "Numele locației",
    displayName: "Numele afișat al organizatorului",
    isMainEvent: "Este Main Event?",
    isSeasonPassSale: "Este vânzare de abonamente",
    isPermanent: "Detalii despre desfășurare",
    permanent: "Deschis Permanent",
    oneTime: "Eveniment unic",
    recurring: "Eveniment recurent",
    mainEventCountyVisibility: "Județul în care este Main Event",
    status: "Status",
    addressLabel: "Adresa",
    visibility: "Vizibilitatea evenimentului",
    countyVisibility: "Vizibilitatea evenimentului pe judete",
    googleLocationLink: "Link de Google Maps pentru locație",
    eventTickets: "Biletele evenimentului",
    displayedNameOfLocation: "Numele afișat al locației",
    downloadData: "Descarcă datele",
    downloadHere: "Descarcă aici.",
    documentProblem: "Există o problemă cu documentul tău!",
    documentValid: "Documentul tău este corect!",
    createData: "Creează produsul",
    saveChanges: "Salvează modificările",
    publishNow: "Publică acum",
    publishing: "Publicare",
    isPublishedTrue: "Publicat",
    isPublishedFalse: "Nepublicat",
    pendingButton: "Așteaptă verificarea",
    unPublish: "Anulează publicarea acum",
    noTicketsSold: {
      title: "Nu s-au vandut bilete",
      content:
        "Deoarece nu s-au vândut bilete pentru acest eveniment, nu există date disponibile pentru a fi descărcate.",
      understand: "Am ințeles",
    },
    visibilityOptions: {
      web: "Doar web",
      app: "Doar app",
      web_and_app: "Pe web și app",
      link_only: "Doar link"
    },
    yourEvents: "Postările tale",
    allOfYourEvents: "Toate postările tale",
    addAPartyNow: "Adaugă o postare acum",
    borderColorTicket: "Culoarea marginii unui bilet",
    trendingBg: "Culoare Trending",
    borderColorVoucher: "Culoarea marginii unui voucher",
    tabs: {
      eventDetails: "Detalii postare",
      transactions: "Tranzacții",
      taxReports: "Rapoarte fiscale",
      statistics: "Statistici",
      reservationsCalendar: "Calendar rezervări",
      reservationsTable: "Tabel rezervări",
      tickets: "Bilete",
      floorPlan: "Plan",
      seatingMap: "Hartă locuri",
      sessions: "Sesiuni",
      seasonPasses: "Abonamente"
    },
    companyNotApprovedTitle: "Te rugăm să îți verifici compania",
    companyNotApproved:
      "Compania ta nu este încă verificată. Te rugăm să introduci datele companiei și să le trimiți pentru aprobare. După verficarea companiei, poți începe să publici.",
    companyPendingTitle: "Detaliile companiei tale sunt în proces de verificare",
    companyPending:
      "Compania ta nu este încă verificată. Te rugăm să aștepți pentru a se finaliza verificarea.",
    cancel: "Anulează",
    rating: "Rating",
    reviewsCount: "Numărul de recenzii",
    priceRangeStart: "Prețul minim",
    priceRangeEnd: "Prețul maxim",
    program: "Programul",
    eventEditor: {
      publishDialogTitle: "Ești sigur că vrei să publici evenimentiul?",
      publishDialogContent:
        "Nu vei mai putea modifica biletele după această acțiune. Asigură-te că ai raportat biletele la DITL. Poți găsi formularul DITL",
      publishDialogLink: "aici",
      publishDialogAgreeButton: "Publică",
      publishDialogDisagreeButton: "Renunță",
    },
    strechToSeeMoreColumns:
      "Puteti sa vedeti mai multe coloane daca folosit proprietatea de strech din setari",
    floorPlan: {
      buildFirstTitle: "Construiește primul tău plan",
      buildFirstDescription: "Odată ce definești toate zonele și mesele, poți începe să creezi planul.",
      buildFirsOptionstDescription: "Odată ce definești toate categoriile și opțiunile rezervabile, poți începe să creezi planul.",
      startBuilding: "Începe să Construiești",
      availableItems: "Opțiuni Disponibile",
      addAll: "Adaugă Toate",
      removeAll: "Șterge Toate",
      exitEditor: "Ieși din Editor",
      saveChanges: "Salvează Modificările",
      managementView: "Plan Management",
      customerView: "Plan Utilizatori",
      select: "Selectează",
      draw: "Desenează",
      reCenter: "Recentrează",
      image: "Imagine",
      zoomIn: "Zoom In",
      zoomOut: "Zoom Out",
      text: "Text",
      editTitle: "Editezi planul?",
      editContent: "Recomandăm să faci asta în afara orelor de lucru."
    }
  },

  deleteEvent: {
    errorName: "Nu ați introdus corect numele postării",
    dialogTitle: "Ștergeți această postare?",
    dialogSubtitle: "Confirmați ștergerea introducând",
    dialogSubtitleVariant1: "numele postării",
    dialogSubtitleVariant2: "următorul cuvânt",
    dialogSubtitleVariant3:
      "Acest eveniment nu poate fi șters pentru că au fost vândute bilete. " +
      "Dacă doriți ca acest eveniment să nu mai poată fi accesat de către utilizatori vă rugăm să îi dați unpublish " +
      "și să contactați administratorul în caz că aveți nevoie de ajutor suplimentar.",
  },
  duplicateListing: {
    dialogTitle: "Doriți duplicarea aceastei postări?",
    dialogSubtitle:
      "Se va creea o nouă postare cu status draft utilizând datele acestei postări",
  },

  staticPages: {
    contactUs: {
      title: "Contactează-ne",
      pageTitle: "Date de contact",
      workProgram: "Program de lucru:",
      workProgramDetails:
        "Luni – Vineri: 09:00 – 17:00 Weekend-uri și sărbători legale: Închis",
      address: "Adresă (pentru corespondență):",
      addressDetails:
        "Sat Remetea Chioarului, Comuna Remetea Chioarului, Nr. 279, Județ Maramureș; Cod postal: 437230",
      phone: "Telefon",
    },
    cookiesPolicy: {
      title: "Politica de cookies",
    },
    termsAndConditions: {
      title: "Termeni și condiții",
    },
    privacyPolicy: {
      title: "Politica de confidențialitate",
    },
  },

  messages: {
    warnUserToSaveChanges:
      "Pentru ca poza să fie salvată te rugăm să apeși pe butonul de 'Salvează modificările'.",
    moduleCreatedSuccessfully: "Modul Creat cu Succes.",
    moduleCreatedError: "Eroare la crearea modulului.",
    moduleDeletedSuccessfully: "Modul șters cu succes.",
    moduleDeletedError:
      "Eroare la ștergerea modulului. Vă rugăm să ștergți înainte toate datele care țin de modul.",
    areaCreateSuccessfully: "Zona a fost creată cu succes",
    areaCreateError: "Eroare la crearea zonei",
    areaUpdatedSuccessfully: "Zona a fost actualizată cu succes",
    areaUpdateError: "Eroare la actualizarea zonei.",
    areaDeleteSuccessfully: "Zona a fost ștearsă cu succes",
    areaDeleteError: "Eroare la ștergerea zonei.",
    categoryCreateSuccessfully: "Categoria a fost creată cu succes",
    categoryCreateError: "Eroare la crearea categoriei",
    categoryUpdatedSuccessfully: "Categoria a fost actualizată cu succes",
    categoryUpdateError: "Eroare la actualizarea categoriei.",
    categoryDeleteSuccessfully: "Categoria a fost ștearsă cu succes",
    categoryDeleteError: "Eroare la ștergerea categoriei.",
    spaceDeleteSuccessfully: "Masa a fost ștearsă cu succes",
    spaceDeleteError: "Eroare la ștergerea mesei.",
    spaceCreateSuccessfully: "Masa a fost creata cu succes",
    spacesCreateSuccessfully: "Mesele au fost create cu succes",
    spaceCreateError: "Eroare la crearea mesei.",
    spacesCreateError: "Eroare la crearea meselor.",
    spaceUpdateSuccessfully: "Masa a fost actualizată cu succes",
    spaceUpdateError: "Eroare la actualizarea mesei",
    optionDeleteSuccessfully: "Opțiunea a fost ștearsă cu succes",
    optionDeleteError: "Eroare la ștergerea opțiunii.",
    optionCreateSuccessfully: "Opțiunea a fost creata cu succes",
    optionsCreateSuccessfully: "Opțiunile au fost create cu succes",
    optionCreateError: "Eroare la crearea opțiunii.",
    optionsCreateError: "Eroare la crearea opțiunilor.",
    optionUpdateSuccessfully: "Opțiunea a fost actualizată cu succes",
    optionUpdateError: "Eroare la actualizarea opțiunii",
    addToFloorPlan: "Nu uita să o adaugi în plan!",
    addMultipleToFloorPlan: "Nu uita să le adaugi în plan!",
    floorPlanIncomplete: "Planurile tale sunt incomplete. Nu uita să adaugi mesele care lipsesc.",
    menuDeleteSuccessfully: "Meniul a fost ștears cu succes",
    menuDeleteError: "Eroare la ștergerea meniului.",
    menuCreateSuccessfully: "Meniul a fost creat cu succes",
    menusCreateSuccessfully: "Meniurile au fost create cu succes",
    menuCreateError: "Eroare la crearea meniului.",
    menusCreateError: "Eroare la crearea meniurilor.",
    menuUpdateSuccessfully: "Meniul a fost actualizat cu succes.",
    menuUpdateError: "Eroare la actualizarea meniului",
    floorPlanSaveSuccessfully: "Planuri salvate cu succes",
    floorPlanSaveError: "Eroare la salvarea planurilor",
    sessionCreatedSuccessfully: "Sesiunea a fost creată cu succes",
    sessionUpdatedSuccessfully: "Sesiunea a fost actualizată cu succes",
    sessionDeletedSuccessfully: "Sesiunea a fost ștearsă cu succes",
    sessionCreateError: "Eroare la salvarea sesiunii.",
    sessionDeleteError: "Eroare la ștergerea sesiunii.",

  },
  companyRegisterForm: {
    title: "Completează formularul pentru a-ți crea contul",
    skipForNow: "Trimite mai târziu",
    saveChangesAndCompleteLater:
      "Salvează și trimite mai târziu",
    saveChanges: "Salvează modificările",
    modifyNow: "Modifică acum",
    messageModalHasErrors:
      "Informațiile au fost salvate, dar formularul nu a fost trimis deoarece unele câmpuri sunt incomplete sau incorecte și necesită atenția ta.",
    titleModalHasErrors: "Informații incomplete sau incorecte",
    messageModalHasNoErrors:
      "Super! Formularul a fost trimis cu succes. Un membru al echipei noastre va lua legătura cu tine în curând.",
    titleModalHasNoErrors: "Formular trimis",
    fiscalInformation: "Informații Fiscale",
    companyRegistrationNumber: "Cod Unic de Înregistrare (CUI)",
    companyName: "Nume Companie",
    companyType: "Tip Companie",
    companyRegistrationCountry: "Țară Înregistrare Companie",
    euVatNumber: "Număr TVA UE",
    tradeRegistryNumber: "Număr Registrul Comerțului",
    invoiceSeries: "Serie facturare",
    invoiceNumber: "Numar facturare",
    europeanUniqueIdentifier: "Identificator European Unic",
    vatObligations: "Plătitor TVA",
    vatObligationsOpt1: "Da",
    vatObligationsOpt2: "Nu",
    companyLegalAddress: "Adresă Legală Companie",
    country: "Tară",
    city: "Oraș",
    county: "Județ",
    streetName: "Strada",
    number: "Număr",
    postalCode: "Cod Poștal",
    legalRepresentative: "Reprezentant Legal",
    firstName: "Prenume",
    lastName: "Nume",
    telephone: "Telefon",
    emailAddress: "Adresă de Email",
    bankDetails: "Detalii Bancare",
    iban: "IBAN",
    bankName: "Nume Bancă",
    swift: "Cod SWIFT",
    currency: "Monedă",
    documents: "Documente",
    uploadTheFollowingRequiredDocuments: "Documente pentru activarea contului",
    uploadTheFollowingOptionalDocuments:
      "Documente pentru înregistrarea biletelor la DITL (opțional)",
    optionalDocumentsDetails:
      "Acest serviciu este destinat organizatorilor de evenimente și este pus la dispoziție de către Nightz, gratuit. " +
      "Acest serviciu poate fi activat/dezactivat din formularul de publicare al evenimentului.",
    getTemplate: "Descarcă Template",
    name: "Nume",
    size: "Mărime",
    type: "Tip",
    modified: "Modificat",
    actions: "Acțiuni",
    finalStep: "Ultimul Pas",
    deleteAll: "Șterge Tot",
    uploadFiles: "Încarcă Fișiere",
    uploadFile: "Încarcă",
    back: "Înapoi",
    next: "Înainte",
    finalStep1: "Super!",
    finalStep2: "Ai completat formularul!",
    finalStep3:
      "Aruncă o ultimă privire pentru a te asigura că toate informațiile sunt corecte.",
    finalStep4:
      "Vom analiza cererea ta în curând și te vom notifica când contul tău va fi activat și vei putea publica evenimente.",
    sendApplication: "Trimite Cererea",
    okButton: "Ok",
    contactDetails: "Detalii de Contact",
    delete: "Șterge",
    view: "Vizualizează",
    saveDataAndSkipForNow: "Datele au fost salvate cu succes.",
    uploadedDocuments: "Documente încărcate",
    noDocumentsUploaded: "Nu ai încărcat niciun document",
    accordingToOriginalText:
      "Toate copiile documentelor trebuie semnate și marcate cu textul 'Conform cu originalul'. ",
  },
  eventTaxReports: {
    ticketRegistration: "Înregistrare Bilete",
    neccesaryDocuments: "Acte necesare depunerii",
    dowloadAll: "Descarcă tot",
    ditlRegistration: "Înregistrare DITL",
    taxReporting: "Raportare Taxe",
    attention: "Atenție!",
    attentionDescription:
      "Companiile care doresc ca raportarea sa fie efectuata de catre Nightz, trebuie sa incarce urmatoarele documente in sectiunea “Afacerea mea”:",
    availableBelow: "disponibil mai jos",
    autogenerated: "autogenerat",
    goToMyBusiness: "Mergi la Afacerea mea",
    justNGO: "(Doar ONG)",
    downloadTemplate: "Descarcă un document de tip template",
    viewDocument: "Vizualizează documentul",
  },

  eventStatistics: {
    dateSelectorLabelOpt1: "7 zile",
    dateSelectorLabelOpt2: "14 zile",
    dateSelectorLabelOpt3: "30 zile",
    dateSelectorLabelOpt4: "Custom",
    salesOverview: "Grafic Vânzări",
    revenueOverview: "Grafic Venituri",
    totalRevenue: "Venit Total",
    totalRevenueTickets: "Venit Total din Bilete",
    totalSoldTickets: "Total Bilete Vândute",
    revenueByTicketType: "Venituri pe Tip de Bilet",
    soldTicketsByTicketType: "Nr. de Bilete Vândute pe Tip de Bilet",
    totalActualSold: "Total",
  },
  userStatistics: {
    registersOverview: "Grafic Registers",
  },
  eventAnalytics: {
    webOverview: "Statistici web după sursă",
    platformOverview: "Statistici după platformă",
    tickets: "Bilete",
    ticketsBySource: "Bilete vândute după sursă",
    reservationsBySource: "Rezervări după sursă",
    ticketsByPlatform: "Bilete vândute după platformă",
    reservationsByPlatform: "Rezervări după platformă",
    linkBuilder: "Generare Link",
    eventLink: "Link postare",
    sourceLink: "Link generat",
    marketingLink: "Link marketing",
    copyLink: "Copiază link",

    marketingDescription: "Creează link-uri personalizate pentru a urmări de unde vin clienții. De exemplu, poți seta link-uri diferite pentru campaniile tale de Instagram, Facebook, TikTok sau Mail.",
    source: "Nume sursă",
    linkCopied: "Link copiat!",
    table: {
      source: "Sursă",
      sessions: "Sesiuni",
      addToCart: "Adăugari în cart",
      reservations: "Rezervări",
      purchases: "Cumpărări",
      revenue: "Venituri"
    }
  },
  invoicesTable: {
    create: "Crează",
    tableTitle: "Facturi",
    invoiceDetails: "Detalii factură",
    invoiceTotal: "Total",
    invoicePaid: "Plătit",
    invoiceUnpaid: "Neplătit",
    changeStatus: "Schimbă statusul",
    exportPdf: "Exportă pdf",
    exportXml: "Exportă xml",
    deleteInvoices: "Șterge facturi",
    documentType: "Tipul documentului",
    documentNumberInputPlaceholder: "Cautati dupa numarul documentului",
    companyNameInputPlaceholder: "Cautati dupa numele companiei",
    eventInputPlaceholder: "Cautati dupa numele evenimentului",
    amount: "Sumă",
    type: "Tip",
    created: "Creat",
    company: "Companie",
    status: "Status",
    noInvoices: "Nu există facturi, incercati filtrari",
    changeStatusTo: "Schimbă statusul în",
    statues: {
      invoiced: "FACTURAT",
      paid: "PLĂTIT",
    },
    invoiced: "Facturat",
    paid: "Plătit",
    name: "Nume",
    companyName: "Numele companiei",
    content: "Conținut",
    actions: "",
    documentName: "Denumirea",
    startDate: "Data de început",
    endDate: "Dată de sfârșit",

    formattedType: {
      INVOICE: "Factură",
      AUTO_INVOICE: "Autofactură",
      COMPENSATION_AGREEMENT: "Acord de compensare",
    },
    invoice: "Factură",
    autoInvoice: "Autofactură",
    compenAgreement: "Acord de compensare",

    INVOICE: "Factură",
    AUTO_INVOICE: "Autofactură",
    COMPENSATION_AGREEMENT: "Acord de compensare",
  },
  seasonPassesTable: {
    seasonPass: "Abonament",
    tableTitle: "Abonamente",
    seasonPasses: "Abonamente",
    included: "Inclus în abonament",
    availablePasses: "Abonamente disponibile"
  },
  transactionsTable: {
    tableTitle: "Tranzacții",
    eventTransactions: "Tranzacțiile evenimentului",
    export: "Exportă",
    createInvoice: "Creează Factură",
    searchIdAndSeries: "Caută după ID și Serie",
    searchNameMailPhone: "Caută după Nume, Email sau Telefon",
    orderId: "ID Comandă",
    clientOrderStatus: "Status Comandă Client",
    purchaseDate: "Data Achiziției",
    tickets: "Bilete",
    orderID: "Id comandă",
    purchaseDate: "Data achiziției",
    invoicingStatus: "Statusul facturii ",
    name: "Nume",
    phone: "Telefon",
    email: "Email",
    total: "Total",
    event: "Eveniment",
    company: "Companie",
    companyInvoiceStatus: "Status Factură Companie",
    orderStatus: "Status Comandă",
    genericError: "A apărut o eroare! Vă rugăm să reîncercați.",
    documentType: "Tipul documentului",
    startDate: "Dată de început",
    endDate: "Dată de sfârșit",
    status: "Status",
    export: "Exportă",
    statuses: {
      COMPLETED: "COMPLET",
      FAILED: "EȘUAT",
      PENDING: "îN AȘTEPTARE",
      REFUNDED: "RAMBURSAT",
    },
    invoice: "Facturează",
    message1: "Nu sunt tranzacții.",
    message2: "Odată ce o tranzacție este efectuată, aceasta va apărea aici.",
    personalDetails: "Detalii Personale",
    businessDetails: "Detalii Companie",
  },
  usersTable: {
    tableTitle: "Utilizatori",
    searchNameMailPhone: "Caută după nume, email sau telefon",
    details: "Detalii",
    name: "Nume",
    phone: "Telefon",
    email: "Email",
    createdAt: "Creat la",
    isDeleted: "Șters",
    totalActivities: "Activități",
    totalReservations: "Rezervări",
    totalFriends: "Prieteni",
    totalCompletedOrders: "Comenzi",
    lastReservation: "Ultime rezervare",
    lastOrder: "Ultima comandă",
    totalSpent: "Total cheltuit",
    phoneCampaign: "Campanie telefon",
    emailCampaign: "Campanie email",
    agreedToCampaign: "Poate fi contactat",
    notificationCampaign: "Campanie notificări",
    genericError: "A apărut o eroare! Vă rugăm să reîncercați.",
    startDate: "Dată de început",
    endDate: "Dată de sfârșit",
    reservationStartDate: "Dată de început ultima rezervare",
    reservationEndDate: "Dată de sfârșit ultima rezervare",
    orderStartDate: "Dată de început ultima comandă",
    orderEndDate: "Dată de sfârșit ultima comandă",
    clearDates: "Șterge filtrele",
    deletedStatus: "Status",
    statuses: {
      ALL: "TOȚI",
      EXISTING: "EXISTENȚI",
      DELETED: "ȘTERȘI",
    },
    message1: "Nu există utilizatori.",
    message2: "Odată ce un cont e creat, va apărea aici",
    true: "Da",
    false: "Nu"
  },

  invoicesDetails: {
    titlePage: "Detalii Facturi",
    currentFilters: "Filtrele curente",
    eventId: "ID Eveniment",
    createdFrom: "Creat de la",
    createdTo: "Creat până la",
    companyId: "ID Companie",
    noDraftsData: "Nu există date pentru facturi în stadiul de draft",
  },

  ticketTable: {
    name: "Nume",
    serialNumber: "Număr Serie",
    initialTickets: "Bilete inițiale",
    initialVouchers: "Vouchere inițiale",
    remainingTickets: "Bilete disponibile",
    remainingVouchers: "Vouchere disponibile",
    displayedPrice: "Preț afișat",
    visibility: "Vizibilitate",
    genericError: "A apărut o eroare! Vă rugăm să reîncercați.",
    ticketTableNoDataTitle: "Nu există date disponibile pentru afișare",
    ticketTableNoDataDescription:
      "Odată ce un bilet este cumpărat, acesta va apărea aici",
    excelOptions: {
      ticketsOnly: "Doar Bilete",
      filteredTickets: "Bilete Filtrate",
    },
  },
  documents: {
    registrationCertificatefromNationalTradeRegistry:
      "Certificat unic de înregistrare / Certificat de înregistrare fiscală",
    contractNightzB2B: "Contract Nightz B2B",
    termsAndConditionsForPartners: "Termeni și condiții pentru parteneri",
    decontForm: "Formular decont",
    articleOfIncorporation: "Copie Act Constitutiv",
    ticketRegistrationForm: "Formular Înregistrare Bilete",
    mandateForNightz: "Împuternicire pentru Nightz",
    idCard: "Act de identitate",
    articleOfAssociation: "Statutul societății",
    unsoldTicketsForm: "Cerere Casare Bilete Nevandute",
    wasGenerated: "Documentul {{documentName}} a fost generat",
    wasNotGenerated: "Nu s-a putut genera documentul {{documentName}}",
  },
  deletedMessages: {
    deletedName: "Nume șters",
    deletedEmail: "Email șters",
    deletedPhone: "Telefon șters",
    deletedCompany: "Companie șters",
    deletedAccount: "Cont șters",
    deletedCui: "Cui șters",
    deletedStatus: "Status șters",
  },
  apiErrorCodes: {
    NIGHTZ_ERROR_SEATSIO_BOOKING_FAILED:
      "Locurile nu mai sunt disponibile. Vă rugăm să alegeți locuri diferite! Acest lucru se întâmplă dacă timpul de păstrare pentru locuri a expirat și altcineva le-a cumpărat. Daca locurile blocate nu au fost cumparate ele devin din nou libere in 15 min",
    NIGHTZ_ERROR_RESERVATION_FAILED:
      "Comanda nu este posibilă pentru că rezervarea configurată nu mai este posibilă. Vă rugăm să ștergeți rezervarea din coș și să încercați cu altă configurație",
  },

  resourceNotAvailable: {
    title: "Resursa nu este disponibilă",
    description:
      "Ne pare rău, nu am putut încărca resursa pe care o căutați. Poate că nu v-ați conectat cu utilizatorul corect",
  },
};

export default ro;
